import { Component, OnInit, Inject, ViewChild, TemplateRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatTableDataSource, MatTable } from '@angular/material';
import { TimeService } from 'src/app/time.service';
import { Duration } from 'luxon';
import { HttpService } from 'src/app/http.service';
import { SnackbarService } from 'src/app/snackbar.service';
import { Messages } from 'src/app/constants/messages';
import { ValidationService } from 'src/app/validation.service';
import { MapModalComponent } from 'src/app/map-modal/map-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationModalComponent } from 'src/app/confirmation-modal/confirmation-modal.component';

import { EChartOption } from 'echarts';
import { environment } from 'src/environments/environment';
import { DateTime } from 'luxon';
import { StorageService } from 'src/app/storage.service';
import { Router } from '@angular/router';
import { retry } from 'rxjs/operators';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

declare var google: any;

@Component({
  selector: 'app-shipment-details',
  templateUrl: './shipment-details.component.html',
  styleUrls: ['./shipment-details.component.scss']
})
export class ShipmentDetailsComponent implements OnInit {
  @ViewChild('containTable', { static: true }) containTable: MatTable<any>;
  @ViewChild("openVideos", { static: true }) openVideos: TemplateRef<any>;
  video_URL = this.sanitizer.bypassSecurityTrustResourceUrl(environment.RAISE_CARRIER_INVOICE);
  editLRID = '';
  newLRValue = '';
  showGenerateFreight = false;
  showReGenerateFreight = false;
  showLoader = false;
  updateFreight = false;
  freightInvoices = [];
  regenFreightData: any = {};
  regenerateInvoice = false;
  customInvoiceNumber: any = '';
  estimatedValues = {
    estDistanceKms: '',
    estDistanceMts: 0,
    estTime: ''
  };
  gstin: any = '';

  tax_type;
  warning_message = '';
  reference_no = '';
  ref_lr_id = '';
  hint_message = ''
  customInvoice = false;
  temperatureGraph: EChartOption;
  enableArrival = false;
  enableFinish = false;
  enableDeliveryArrival = false;
  enableDeliveryFinish = false;
  map;
  mapMarkers = [];
  polyline;
  initialLocation: any;
  simMode = false;
  appMode = false;
  gpsMode = false;
  coordinates = [];
  flightPath: any;
  path;
  shipment_data = [];
  pickupTimes = [[]];
  deliveryTimes = [[]];
  src = {
    lat: 0,
    lng: 0
  };
  URD;
  advance_amount = 0;
  epod_warning = '';
  no_epods = true;
  markers: any = {
    sim: [],
    app: [],
    gps: false
  };
  netPayableAmount = 0;
  totalAmount = 0;

  chartData = [];
  uploadContainerSealData: any = {};

  bounds = new google.maps.LatLngBounds();
  picon = {
    url: 'assets/Pickup.svg', // url
    scaledSize: new google.maps.Size(30, 30)
  };
  dicon = {
    url: 'assets/Drop.svg', // url
    scaledSize: new google.maps.Size(30, 30)
  };

  currencySymbol: any;
  freightData: any = {
    shipment_id: '',
    amount_from: {},
    discount: {},
    ref_lr_id: '',
    // ref_lr_type: '',
    additional_charges: {
      labour: { // Porter
        value: 0,
        comment: ''
      },
      // penalty: { // Penalty
      //   value: 0,
      //   comment: ''
      // },
      doc: { // Document Charges
        value: 0,
        comment: ''
      },
      toll: { // Toll
        value: 0,
        comment: ''
      },
      non_hometown_halt: {
        value: 0,
        comment: ''
      },
      insurance: { // Insurance
        value: 0,
        comment: ''
      },
      cancellation: { // Cancellation
        value: 0,
        comment: ''
      },
      detentionCustomer: { 
        value: 0,
        comment: ''
      },
      detentionPlant: { 
        value: 0,
        comment: ''
      },
      extra_pickup: {
        value: 0,
        comment: ''
      },
      extra_delivery: {
        value: 0,
        comment: ''
      },
      LR_charges: {
        value: 0,
        comment: ''
      },
      others: {
        value: 0,
        comment: ''
      },
      green_tax: {
        value: 0,
        comment: ''
      },
      odc_charges: {
        value: 0,
        comment: ''
      },
      rto_fines: {
        value: 0,
        comment: ''
      },
      unloading_charges: {
        value: 0,
        comment: ''
      },
      loading_charges: {
        value: 0,
        comment: ''
      }
    },
    deductible_charges: {
      material_damage: { // Material damaged penalty
        value: 0,
        comment: ''
      },
      material_missing: { // material missing Penalty
        value: 0,
        comment: ''
      },
      vehicle_delay: {//transit delay
        value: 0,
        comment: ''
      },
      carton_damage: {//carton damage
        value: 0,
        comment: ''
      },
      shipper_LR_charges: {// Shipper LR charges
        value: 0,
        comment: ''
      },
      others: {//others
        value: 0,
        comment: ''
      }
    },
    custom_invoice: false,
    custom_invoice_number: '',
  };

  additional_charges: any = {};

  freightType = 0; // 0 estimated, 1 actual

  freightamount: any = {
    estimated: 0,
    actual: 0
  };
  discountAmount: any = {
    percentage: 0,
    amount: 0,
    comment: ''
  };

  measure_unit;

  otherChargesTotal = 0;
  deductibleChargesTotal = 0;
  discountTotal = 0;
  freightSubTotal = 0;
  vatAmount = 0;
  freightTotal = 0;
  isCarrierShipment = false;

  uniqueTypes: any = [{
    name: 'Waybill/LR',
    value: 'Waybill/lr'
  }, {
    name: 'Invoice No.',
    value: 'Invoice'
  }];

  discountTypes: any = [{
    name: 'Percentage',
    value: 'percentage'
  }, {
    name: 'Amount',
    value: 'amount'
  }];
  discountSelected: any = {};
  uniqueNoType: any = {};
  GTAtoGTA;

  shipment: any = {};
  cancelGenerate = false;
  segmentations= [];
  purchase_orders = [];
  // deliveryArrayColumns = ['loc', 'invoices', 'total_value', 'total_nop', 'total_weight', 'rejected_barcodes'];
  deliveryArrayColumns = ['loc', 'invoices', 'total_value', 'total_nop', 'gross_weight', 'net_weight', 'considered_weight']; // , 'rejected_barcodes' removed , 'total_barcodes'
  invoiceHeaders = ['invoices', 'total_value', 'total_nop', 'gross_weight', 'net_weight', 'considered_weight']; // removed , 'total_barcodes'
  trailColumns = ['user', 'user_type', 'comment', 'driver_location', 'date'];
  lrColumns = ['pick', 'drop', 'lr_number']; //
  invoiceColumns = ['description', 'hsn_code', 'sac_code', 'date', 'party_invoice', 'party_name', 'way_bill', 'weight', 'total_amount', 'action']; //
  deductibleColumns = ['description', 'total_amount', 'action'];
  tabIndex = 0;
  green: any;
  freightColumns = ['version_id', 'invoiceNo', 'datetime', 'updated_by', 'freight', 'status', 'comment', 'view', 'edit'];
  containerColums = ['containerNo', 'sealNo', 'action'];



  uploadDocsRef: any;
  containerArray = [[]];
  pickTab = 21;
  containerSealNo: any = [{
    container: '',
    seal: ''
  }];
  actual: any = {}
  shipments_ = [];
  locations = [];
  uploadEpodData: any = {};
  messages = new Messages();
  showChart = false;
  disableGenerateInvoice = false;
  grid_tiles;
  disablePenalty = false;
  country;
  materials_array: any = [];
  subHeader = [];
  disable_subheader = true;
  cHeader = [];
  gst;
  tollCharge;
  greenTaxCharge;

  newCarrierInvoiceArray: any = [];
  carrierInvoiceArray: MatTableDataSource<any>;
  totalPreTaxAmount = 0;
  totalTaxAmount = 0;
  totalCharges = 0;
  gstID = "";
  //isShowBNew = false;
  isNewFlow = false;

  newDeductibleChargeArray: any = [];
  deductibleChargeArray: MatTableDataSource<any>;
  referenceDate: Date;

  descriptionofServices = [
    // { name: 'Freight Amount', value: 'freight_amount' },
    { name: 'Labour', value: 'labour' },
    { name: 'LR Charges', value: 'LR_charges' },
    { name: 'Doc', value: 'doc' },
    { name: 'Insurance', value: 'insurance' },
    { name: 'Cancellation', value: 'cancellation' },
    { name: 'Non HomeTown Halt', value: 'non_hometown_halt' },
    { name: 'Toll', value: 'Toll' },
    { name: 'Extra Delivery', value: 'extra_delivery' },
    { name: 'Extra Pickup', value: 'extra_pickup' },
    { name: 'Detention Customer', value: 'detentionCustomer' },
    { name: 'Detention Plant', value: 'detentionPlant' },
    { name: 'Others', value: 'others' },
    { name: 'Green Tax', value: 'green_tax' },
    { name: 'ODC Charges', value: 'odc_charges' },
    { name: 'RTO Fines', value: 'rto_fines' },
  ];

  damageList = [
    { name: 'Material Damage', value: 'material_damage' },
    { name: 'Material Missing', value: 'material_missing' },
    { name: 'Vehicle Delay', value: 'vehicle_delay' },
    { name: 'Carton Damage', value: 'carton_damage' },
    { name: 'Shipper LR Charges', value: 'shipper_LR_charges' },
    { name: 'Others', value: 'others' },
    { name: 'Discount', value: 'discount' }
  ];

  deductibleChargesList = [{
    name: 'Toll',
    value: 'Toll'
  },
  {
    name: 'Extra Pickup Point',
    value: 'ExtraPickupPoint'
  },
  {
    name: 'Extra Delivery Point',
    value: 'ExtraDeliveryPoint'
  },
  {
    name: 'Detention Charges ',
    value: 'DetentionCharges'
  },
  {
    name: 'Cancellation',
    value: 'Cancellation'
  }
  ];
  comments = "";
  isCarrierInvoiceDisabled = false;
  // isCarrierInvoiceCalculate = false;
  do_number = '';
  e_invoice_bill: any;
  e_invoice_qr_code: any;

  constructor(private dialog: MatDialogRef<ShipmentDetailsComponent>, @Inject(MAT_DIALOG_DATA) public parentData: any,
    private timeService: TimeService, private http: HttpService, private time: TimeService, private dialogModal: MatDialog,
    private snackbar: SnackbarService, private valid: ValidationService, private storage: StorageService, private route: Router,
    private translation: TranslateService, private sanitizer: DomSanitizer) {
    this.showChart = environment.country !== 'IN';
    this.country = environment.country;
    this.isCarrierShipment = (!this.parentData.shipper ? true : false);
    if (this.showChart && !this.isCarrierShipment) {
      this.grid_tiles = 8;
    } else if (!this.showChart && !this.isCarrierShipment) {
      this.grid_tiles = 7;
    } else if (this.showChart && this.isCarrierShipment) {
      this.grid_tiles = 7;
    } else {
      this.grid_tiles = 6;
    }
  }

  ngOnInit() {
    // this.initMap();
    // console.log('www');
    this.shipmentInit();
    const currency = JSON.parse(localStorage.getItem('carriers'));
    this.currencySymbol = currency[0].country.currency.symbol;
    this.additional_charges.unloading_charges = this.parentData.others.unloading_charges;
    this.additional_charges.loading_charges = this.parentData.others.loading_charges;
    this.tollCharge = 0;
    this.greenTaxCharge = 0;
  }

  getFilteredServices(index: number) {
    console.log("this.carrierInvoiceArray", this.carrierInvoiceArray)
    const selectedServices = this.carrierInvoiceArray.data.filter((_, i) => i !== index).map(item => item.service_desc);
    console.log("selectedServices", selectedServices)
    return this.descriptionofServices.filter(unit => !selectedServices.includes(unit.value));
  }

  calculateGST() {
    if (!this.URD && !this.GTAtoGTA) {
      if (this.country == 'IN') {

        if (this.tax_type == 'FCM12') {
          if (this.shipment.transit_type == 'INTRA') {
            this.gst = environment.FCM12_GST;
          } else {
            this.gst = environment.FCM12_GST;
          }
        } else if (this.tax_type == 'FCM18') {
          if (this.shipment.transit_type == 'INTRA') {
            this.gst = environment.FCM18_GST;
          } else {
            this.gst = environment.FCM18_GST;
          }
        } else if (this.tax_type == 'RCM') {
          if (this.shipment.transit_type == 'INTRA') {
            this.gst = environment.RCM_GST;
          } else {
            this.gst = environment.RCM_GST;
          }
        }
      } else {
        this.gst = environment.FCM12_GST;
      }
    }
  }


  getAdditionalCharges() {
    this.http.get('constants/custom_additional_charges?shipper=' + this.shipment.shipper_id).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.additional_charges = response.data ? response.data.additional_charges : '';
        // this.GTAtoGTA = response.data.GTAtoGTA;
        this.GTAtoGTA = response.data ? response.data.GTAtoGTA : '';
        this.calculateGST();
        // this.getAdditionalChargesFields();
      }
    });
  }

  shipmentInit() {
    // console.log('init');
    // console.log(this.parentData);
    this.shipment.billing_address = this.parentData.constants ? this.parentData.constants.billing_address : '';
    this.shipment.shipper_id = this.parentData.shipper ? this.parentData.shipper._id : '';
    this.shipment._id = this.parentData._id;
    this.shipment.uom = this.parentData.uom;
    this.shipment.oin = (this.parentData.order) ? this.parentData.order.OIN : 'N/A';
    this.shipment.detentionCustomer = this.parentData.detentionCustomer || this.parentData.detention_at_pickup;
    this.shipment.detentionPlant = this.parentData.detentionPlant || this.parentData.detention_at_pickup;
    this.shipment.detention_charges_customer = 0;
    this.shipment.detention_charges_plant = 0;
    if (this.parentData.detention_charges_customer) this.shipment.detention_charges_customer += this.parentData.detention_charges_customer;
    if (this.parentData.detention_charges_plant) this.shipment.detention_charges_plant += this.parentData.detention_charges_plant;
    if (this.parentData.detention_charges_at_pickup) this.shipment.detention_charges += this.parentData.detention_charges_at_pickup;
    this.tabIndex = this.parentData.tabIndex || 0;
    this.gstin = this.parentData.gst || 'N/A';
    this.setTransitType();
    // this.shipment.transit_type = this.parentData.transit_type;
    this.URD = this.parentData.URD || false;
    this.tax_type = this.parentData.tax_type;
    this.advance_amount = this.parentData.advance_amount ? this.parentData.advance_amount : 0;
    if (this.tabIndex == 6 && this.parentData.generateFreight) {
      this.freightData.shipment_id = this.parentData._id;
      this.showGenerateFreight = false;
      this.getAdditionalCharges();
      this.getFreightInvoices(this.parentData._id);

    } else if (this.tabIndex == 6 && !this.parentData.generateFreight) {
      this.showGenerateFreight = false;
      this.getAdditionalCharges();
      this.getFreightInvoices(this.parentData._id);


    }
    this.shipment.unique_code = this.parentData.SIN || 'NA';
    if (this.parentData.latest_status === 'PNDG') {
      this.shipment.shipment_status = 'Pending';
    } else if (this.parentData.latest_status === 'ALC') {
      this.shipment.shipment_status = 'Allocated';
    } else if (this.parentData.latest_status === 'ACPT') {
      this.shipment.shipment_status = 'Accepted';
    } else if (this.parentData.latest_status === 'ASN') {
      this.shipment.shipment_status = 'Assigned';
    } else if (this.parentData.latest_status === 'ITNS') {
      this.shipment.shipment_status = 'In Transit';
    } else if (this.parentData.latest_status === 'CPTD') {
      this.shipment.shipment_status = 'Completed';
    } else if (this.parentData.latest_status === 'SP') {
      this.shipment.shipment_status = 'Towards Pickup';
    } else if (this.parentData.latest_status === 'AP') {
      this.shipment.shipment_status = 'At Pickup';
    } else if (this.parentData.latest_status === 'ALD') {
      this.shipment.shipment_status = 'At Delivery';
    }
    else if (this.parentData.latest_status === 'ABTR') {
      this.shipment.shipment_status = 'About to Reach';
    } else {
      this.shipment.shipment_status = 'Cancelled';
    }
    this.shipment.created_at = this.timeService.toShortDate(this.parentData.created_at) || '';
    this.shipment.shipper = this.parentData.shipper ? (this.parentData.shipper.parent_name + ' | ' + this.parentData.shipper.name) : 'NA';
    this.shipment.pickups = (this.parentData.pickups && this.parentData.pickups.length) ? this.parentData.pickups : [];
    this.shipment.pickups.forEach((element) => {
      if ((element.docs && element.docs.length) || (element.other_docs && element.other_docs.length)) {
        element.all_docs = element.other_docs.concat(element.docs);
      }
    });
    if(this.parentData.do_number && this.parentData.do_number.length){
      this.do_number = this.parentData.do_number.join(",");
    }

    this.shipment.pickups.forEach((element, i) => {
      const temp: any = {};
      temp.container = '';
      temp.seal = '';
      this.pickupTimes[i] = [];
      this.containerSealNo[i] = temp;
      if (element.numbers && element.numbers.length) {
        const tempArr: any = [];
        element.numbers.forEach(num => {
          const temp: any = {};
          temp.containerNo = num.container;
          temp.sealNo = num.seal;
          temp.action = '';
          tempArr.push(temp);
        });
        this.containerArray[i] = tempArr;
      }
      const tempArrival: any = {};
      tempArrival.date = (element.arrived_at) ? new Date(element.arrived_at) : 'N/A';
      tempArrival.time = (element.arrived_at) ? this.toTime(element.arrived_at) : 'N/A';
      this.pickupTimes[i].push(tempArrival);
      element.arrivalTime = tempArrival;
      const tempFinished: any = {};
      tempFinished.date = (element.finished_at) ? new Date(element.finished_at) : 'N/A';
      tempFinished.time = (element.finished_at) ? this.toTime(element.finished_at) : 'N/A';
      this.pickupTimes[i].push(tempFinished);
      element.finishTime = tempFinished;

      if (element.invoices) {
        element.invoices.forEach((inv) => {
          let tot = 0;
          if (inv.invoice) {
            inv.invoice.forEach(item => tot += item.rejected_nop);
            inv.total_rejected = tot;
          }
        });
      }

    });
    this.shipment.scheduledPickDate = this.timeService.toShortDateTime(this.parentData.pickup_date, 'dd-MMM, hh:mm a');
    this.shipment.scheduledDropDate = this.timeService.toShortDateTime(this.parentData.delivery_date, 'dd-MMM, hh:mm a');
    this.shipment.deliveries = (this.parentData.deliveries && this.parentData.deliveries.length) ? this.parentData.deliveries : [];
    this.shipment.deliveries.forEach((element) => {
      if ((element.docs && element.docs.length) || (element.other_docs && element.other_docs.length)) {
        element.all_docs = element.other_docs.concat(element.docs);
      }
    });
    this.shipment.deliveries.forEach((element, i) => {
      this.deliveryTimes[i] = [];
      const tempArrival: any = {};
      tempArrival.date = (element.arrived_at) ? new Date(element.arrived_at) : 'N/A';
      tempArrival.time = (element.arrived_at) ? this.toTime(element.arrived_at) : 'N/A';
      this.deliveryTimes[i].push(tempArrival);
      element.arrivalTime = tempArrival;
      const tempFinished: any = {};
      tempFinished.date = (element.finished_at) ? new Date(element.finished_at) : 'N/A';
      tempFinished.time = (element.finished_at) ? this.toTime(element.finished_at) : 'N/A';
      this.deliveryTimes[i].push(tempFinished);
      element.finishTime = tempFinished;
      element.epodUploader = element.epod_uploaded_by_shipper
        ? `Shipper Unit - ${element.epod_uploaded_by_shipper.name}`
        : element.epod_uploaded_by_carrier
        ? `Carrier Unit - ${element.epod_uploaded_by_carrier.name}`
        : "";
      element.epods = (element.epods && element.epods.length) ? element.epods.map(element => {
        return {
          extension: element.substr(element.lastIndexOf('.')).substr(1),
          link: element
        };
      }) : [];
    });
    for (let i = 0; i < this.shipment.deliveries.length; i++) {
      if (this.shipment.deliveries[i].epods.length) {
        this.no_epods = false;
        break;
      }
    }

    if (this.no_epods) {
      this.epod_warning = this.translation.instant('SHIPMENTDETAILS.no_epods_upload');
    }

    // delivery invoices details
    for (let i = 0; i < this.shipment.deliveries.length; i++) {
      this.shipment.deliveries[i].invoices = [];
      for (let l = 0; l < this.shipment.pickups.length; l++) {
        for (let j = 0; j < this.parentData.invoices.length; j++) {
          // group invoices by their pickup id and delivery id
          if ((this.shipment.deliveries[i]._id == this.parentData.invoices[j].delivery_id._id) && (this.parentData.invoices[j].pickup_id == this.shipment.pickups[l]._id)) {
            if (this.parentData.invoices[j].invoice) {
              this.parentData.invoices[j].invoice.map((element) => {
                element.invoice_products = (element.invoice_products && element.invoice_products.length) ? element.invoice_products : [];

                if (element.status && element.status.length) {
                  element.cHeader = ['material', 'batch', 'manuf', 'mrp', 'no_pcs_per_case', 'total'];
                  element.subHeader = [];
                  element.status.forEach((status) => {
                    if (status == 'FULL') {
                      element.full_checked = true; // initial state of Full checkbox
                      element.subHeader = [];
                      element.cHeader = [];
                      element.disable_subheader = false;
                      element.disable_table = true;
                    } else if (status == 'SRT') {
                      element.missing_checked = true; // initial state of Short checkbox
                      const index = this.calculateIndex(status, element);
                      element.cHeader.splice(index, 0, 'cases-s', 'pcs-s');
                      this.calculateSubIndex(status, element);
                      element.disable_table = false;
                    } else if (status == 'DMG') {
                      element.damaged_checked = true; // initial state of Damaged checkbox
                      const index = this.calculateIndex(status, element);
                      element.cHeader.splice(index, 0, 'cases-d', 'pcs-d');
                      this.calculateSubIndex(status, element);
                      element.disable_table = false;
                    } else if (status == 'REJ') {
                      element.rejected_checked = true; // initial state of Rejected checkbox
                      const index = this.calculateIndex(status, element);
                      element.cHeader.splice(index, 0, 'cases-r', 'pcs-r');
                      this.calculateSubIndex(status, element);
                      element.disable_table = false;
                    } else if (status == 'CARTON_DMG') {
                      element.carton_damage_checked = true; // initial state of Rejected checkbox
                      const index = this.calculateIndex(status, element);
                      element.cHeader.splice(index, 0, 'cases-cd', 'penalty-cd');
                      this.calculateSubIndex(status, element);
                      element.disable_table = false;
                    }

                  });
                  element.full_disabled = element.damaged_disabled = element.rejected_disabled = element.missing_disabled = element.carton_damage_disabled = true; // initial state of all checkboxes (Disabled)
                  this.measure_unit = element.uom;
                  let invoice_products = [];
                  if (element.invoice_products && element.invoice_products.length) {

                    element.invoice_products.forEach((inv) => {
                      const temp: any = {}
                      temp.material = inv.material_SKU;
                      temp.selectedMaterial = temp.material;
                      temp.batch = inv.batch;
                      temp.MFG_date = inv.MFG_date
                      temp.no_of_cases = inv.no_of_cases;
                      temp.cost_per_pcs = inv.cost_per_pcs;
                      temp.pcs_in_case = inv.pcs_in_case;
                      temp._id = inv._id;
                      temp.pcs = 0;

                      //  temp.total = element.penalty_amount;
                      if (inv.missing && inv.missing.no_of_cases) {
                        temp.missing_cases = inv.missing.no_of_cases;
                      }
                      if (inv.missing && inv.missing.no_of_pcs) {
                        temp.missing_pcs = inv.missing.no_of_pcs;
                      }
                      if (inv.damaged && inv.damaged.no_of_cases) {
                        temp.damaged_cases = inv.damaged.no_of_cases
                      }
                      if (inv.damaged && inv.damaged.no_of_pcs) {
                        temp.damaged_pcs = inv.damaged.no_of_pcs;
                      }
                      if (inv.rejected && inv.rejected.no_of_cases) {
                        temp.rejected_cases = inv.rejected.no_of_cases
                      }
                      if (inv.rejected && inv.rejected.no_of_pcs) {
                        temp.rejected_pcs = inv.damaged.no_of_pcs
                      }
                      if (inv.carton_damage) {
                        temp.carton_damage = inv.carton_damage;
                      }
                      if (inv.total_carton) {
                        temp.carton_damage_penalty = inv.total_carton;
                      }
                      temp.total = inv.penalty_amount;
                      invoice_products.push(temp);
                    });
                    element.invoice_products = new MatTableDataSource(invoice_products);
                  } else {
                    element.cHeader = [];
                    element.subHeader = [];
                    element.status.forEach((status) => {
                      if (status == 'FULL') {
                        element.full_checked = true; // initial state of Full checkbox
                        element.subHeader = [];
                        element.cHeader = [];
                        element.disable_subheader = false;
                        element.disable_table = true;
                      } else if (status == 'SRT') {
                        element.missing_checked = true; // initial state of Short checkbox
                        const index = this.calculateIndex(status, element, 0);
                        element.cHeader.splice(index, 0, 'cases-s', 'pcs-s');
                        this.calculateSubIndex(status, element, 0);
                        element.disable_table = false;
                      } else if (status == 'DMG') {
                        element.damaged_checked = true; // initial state of Damaged checkbox
                        const index = this.calculateIndex(status, element, 0);
                        element.cHeader.splice(index, 0, 'cases-d', 'pcs-d');
                        this.calculateSubIndex(status, element, 0);
                        element.disable_table = false;
                      } else if (status == 'REJ') {
                        element.rejected_checked = true; // initial state of Rejected checkbox
                        const index = this.calculateIndex(status, element, 0);
                        element.cHeader.splice(index, 0, 'cases-r', 'pcs-r');
                        this.calculateSubIndex(status, element, 0);
                        element.disable_table = false;
                      } else if (status == 'CARTON_DMG') {
                        element.carton_damage_checked = true; // initial state of Rejected checkbox
                        const index = this.calculateIndex(status, element, 0);
                        element.cHeader.splice(index, 0, 'cases-cd', 'penalty-cd');
                        this.calculateSubIndex(status, element, 0);
                        element.disable_table = false;
                      }

                    });
                    const temp: any = {}

                    //  temp.total = element.penalty_amount;
                    if (element.missing) {
                      temp.missing_cases = element.missing.nop;
                      temp.missing_pcs = element.missing.pcs;
                    }
                    if (element.damaged) {
                      temp.damaged_cases = element.damaged.nop;
                      temp.damaged_pcs = element.damaged.pcs;
                    }
                    if (element.rejected) {
                      temp.rejected_cases = element.rejected.nop;
                      temp.rejected_pcs = element.damaged.pcs;
                    }
                    if (element.carton_damage) {
                      temp.carton_damage = element.carton_damage;
                    }
                    if (element.total_carton) {
                      temp.carton_damage_penalty = element.total_carton;
                    }
                    element.invoice_products.push(temp);
                  }
                } else {
                  this.disable_subheader = false;
                  element.disable_table = true;
                  element.cHeader = element.subHeader = [];
                  element.full_checked = element.damaged_checked = element.rejected_checked = element.missing_checked = element.carton_damage_checked = false; // initial state of checkboxes is false
                  element.full_disabled = element.damaged_disabled = element.rejected_disabled = element.missing_disabled = element.carton_damage_disabled = true; // initial state of all checkboxes (Disabled)
                  let invoice_products = [{
                    material: '',
                    batch: '',
                    MFG_date: '',
                    no_of_cases: 0,
                    cost_per_pcs: 0,
                    pcs_in_case: 0,
                    cost_per_carton: 10,
                    pcs: 0,
                    total: 0,
                    is_display: false
                  }];
                  element.invoice_products = new MatTableDataSource(invoice_products);
                }
              });
              this.shipment.deliveries[i].invoices.push({
                invoice: this.parentData.invoices[j].invoice,
                pdf_link: this.parentData.invoices[j].commerical_inv_pdf ? this.parentData.invoices[j].commerical_inv_pdf : '',
                p_label: 'P' + (l + 1),
                edit_enable: false,
                comments: this.parentData.invoices[j].comments ? this.parentData.invoices[j].comments : '',
                _id: this.parentData.invoices[j]._id
              });
            }
          }
        }
      }
    }

    this.shipment.driver = (this.parentData.driver) ? this.parentData.driver :
      ((this.parentData.assigned_driver) ? this.parentData.assigned_driver : 'N/A');
    this.shipment.notAccepted = (!this.parentData.driver) ? true : false;
    this.shipment.order = this.parentData.order ? this.parentData.order : '';
    this.segmentations = (this.parentData.order && this.parentData.order.segmentations) ? this.parentData.order.segmentations : [];
    this.purchase_orders = (this.parentData.order && this.parentData.order.purchase_orders) ? this.parentData.order.purchase_orders : [];
    this.shipment.inTransit = (this.shipment.shipment_status == 'In Transit' || this.shipment.shipment_status == 'Towards Pickup' || this.shipment.shipment_status == 'At Pickup' || this.shipment.shipment_status == 'At Delivery')

    this.shipment.remainingDistance = (this.parentData.trip_tracker && this.parentData.trip_tracker.remaining_distance) ?
      (this.shipment.inTransit ? (this.parentData.trip_tracker.remaining_distance / 1000).toFixed(0) + ' kms' : '--') : '--';
    this.shipment.remainingTime = (this.parentData.trip_tracker && this.parentData.trip_tracker.remaining_duration) ?
      (this.shipment.inTransit ? (this.timeService.daysFormat(this.parentData.trip_tracker.remaining_duration)) : '--') : '--';

    this.shipment.actual_distance = (this.parentData.trip_tracker && this.parentData.trip_tracker.travelled_distance) ?
      ((this.shipment.inTransit || this.shipment.shipment_status == 'Completed') ? (this.parentData.trip_tracker.travelled_distance / 1000).toFixed(0) + ' kms' : 'N/A') : 'N/A';
    this.shipment.actual_duration = (this.parentData.trip_tracker && this.parentData.trip_tracker.travelled_duration) ?
      ((this.shipment.inTransit || this.shipment.shipment_status == 'Completed') ? (this.timeService.toDayMinSec(this.parentData.trip_tracker.travelled_duration)) : 'N/A') : 'N/A';
    this.shipment.lorry_receipt = [];
    if (this.parentData.carrier_waybills && this.parentData.carrier_waybills.length) {
      this.parentData.carrier_waybills.forEach(element => {
        this.shipment.lorry_receipt.push(element);
      });
    }
    //actual and estimated price
    this.shipment.estimated = {};
    this.shipment.actual = {};

    //estimated price
    if (this.parentData.estimated) {
      //estimated carrier price / carrier price per weight
      if (this.parentData.estimated.price) {
        this.shipment.estimated.price = this.parentData.estimated.price;
        this.freightamount.estimated = this.parentData.estimated.price;
      } else if (this.parentData.estimated.price_per_weight) {
        this.shipment.estimated.price = this.parentData.estimated.price_per_weight;
      } else if (this.parentData.estimated.price_per_pallet) {
        this.shipment.estimated.price = this.parentData.estimated.price_per_pallet;
      } else {
        this.shipment.estimated.price = 'N/A';
      }
    } else {
      this.shipment.estimated.price = 'N/A';
    }

    //actual price
    if (this.parentData.actual) {
      //actual carrier price
      if (this.parentData.actual.price) {
        // console.log(this.parentData.actual.price);
        this.shipment.actual.price = this.parentData.actual.price;
        this.freightamount.actual = this.parentData.actual.price;
      } else {
        this.shipment.actual.price = 'N/A';
      }
    } else {
      this.shipment.actual.price = 'N/A';
    }

    // estimated distance and duration of shipment
    if (this.parentData.estimated) {
      this.shipment.estimated.distance = this.parentData.estimated.distance ? (this.round(this.parentData.estimated.distance / 1000)).toFixed(2) + 'kms' : 'N/A';
      this.shipment.estimated.duration = this.parentData.estimated.duration ? this.getHoursandMinutes(this.parentData.estimated.duration) : 'N/A';
    } else {
      this.shipment.estimated.distance = 'N/A';
      this.shipment.estimated.duration = 'N/A';
    }

    // actual distance and duration of shipment
    if (this.shipment.actual) {
      this.actual.distance = this.shipment.actual.distance ? this.shipment.actual.distance : '';
      this.actual.duration = this.shipment.actual.duration ? this.shipment.actual.duration : '';
    } else if (this.shipment.trip_tracker) {
      this.actual.distance = this.shipment.trip_tracker.travelled_distance ? this.shipment.trip_tracker.travelled_distance : '';
      this.actual.duration = this.shipment.trip_tracker.travelled_duration ? this.shipment.trip_tracker.travelled_duration : '';
    }

    this.shipment.freight = [];
    this.shipment.materials = this.parentData.materials;
    this.shipment.documents = {
      invoice: 'link',
      lr_receipt: 'link',
      eWayBill: 'link'
    };
    this.shipment.trails = [];
    this.parentData.trails.forEach((element, ind) => {
      const temp: any = {
        driver_location: []
      };

      const us = element.who ? (element.who.carrier_user) ? element.who.carrier_user.name : ((element.who.shipper_user) ? element.who.shipper_user.name : '--') : 'N/A';
      temp.user = element.who ? (element.who.driver) ? element.who.driver.name : (element.who.attached_driver) ? element.who.attached_driver.name : us : 'N/A';
      temp.user_type = element.who ? (element.who.driver || element.who.attached_driver) ? 'Driver' : ((element.who.carrier_user) ? 'Carrier' : (element.who.shipper_user) ? 'Shipper' : '--') : 'N/A';

      temp.activity = element.synopsis;
      const key = element.synopsis.split('-');
      const t1 = 'TRAILS.' + key[0];
      temp.synopsisText = (key[1]) ? this.translation.instant(t1) + '-' + key[1] : this.translation.instant(t1);

      temp.comment = element.comments;
      if (element.latitude && element.longitude) {
        temp.driver_location.push(Number(element.longitude));
        temp.driver_location.push(Number(element.latitude));
      } else {
        temp.driver_loc = '--';
      }
      temp.date = (element.created_at) ? this.timeService.toShortDateTime(element.created_at) : '--';

      temp.dateOnly = (element.created_at) ? this.timeService.toShortDateTime(element.created_at, 'dd-MMM-yyyy') : '--';
      temp.timeOnly = (element.created_at) ? this.timeService.toShortDateTime(element.created_at, 'hh:mm a') : '--';
      if (ind === 0 || ind === this.parentData.trails.length - 1) {
        temp.showDate = true;
      } else if (ind > 0 && this.shipment.trails[ind - 1].dateOnly !== temp.dateOnly) {
        temp.showDate = true;
      } else {
        temp.showDate = false;
      }

      this.shipment.trails.push(temp);
    });

  }
  round(num) {
    return Math.round(num);
  }

  //calculate index of the array where short/damaged/rejected header has to be inserted
  calculateIndex(value, invoice, type = 1) {
    if (type) {
      if (value == 'SRT') {//short is selected
        const index = 5;
        return index;
      }
      if (value == 'DMG') {//damaged is selected
        const index_s = invoice.cHeader.indexOf('cases-s');
        if (index_s != -1) {//if short is present
          return (index_s + 2);//short index + 2
        } else {
          return 5;
        }
      }
      if (value == 'REJ') {//rejected is selected
        const index_s = invoice.cHeader.indexOf('cases-s');//index of short_cases
        const index_d = invoice.cHeader.indexOf('cases-d');//index of damaged_cases
        if (index_s != -1 && index_d != -1) {
          return (index_d + 2);
        } else if (index_s == -1 && index_d != -1) {
          return index_d + 2;
        } else if (index_s != -1 && index_d == -1) {
          return index_s + 2;
        } else {
          return 5;
        }
      }

      if (value == 'CARTON_DMG') {
        const index_s = invoice.cHeader.indexOf('cases-s');//index of short_cases
        const index_d = invoice.cHeader.indexOf('cases-d');//index of damaged_cases
        const index_r = invoice.cHeader.indexOf('cases-r');//index of rejected_cases

        if ((index_s != -1 && index_d != -1 && index_r != -1)) {//all three exists
          return (index_r + 2);
        } else if ((index_s == -1 && index_d != -1 && index_r != -1) || (index_s != -1 && index_d == -1 && index_r != -1) || (index_s == -1 && index_d == -1 && index_r != -1)) {//!short & damaged & rejected
          return index_r + 2;
        } else if ((index_s != -1 && index_d != -1 && index_r == -1) || (index_s == -1 && index_d != -1 && index_r == -1)) {//short & damaged & !rejected
          return index_d + 2;
        } else if (index_s != -1 && index_d == -1 && index_r == -1) {//short & !damaged & !rejected
          return index_s + 2;
        } else if ((index_s == -1 && index_d == -1 && index_r == -1)) {//!short & !damaged & !rejected
          return 5;
        }
      }
    } else {
      if (value == 'SRT') {//short is selected
        const index = 0;
        return index;
      }
      if (value == 'DMG') {//damaged is selected
        const index_s = invoice.cHeader.indexOf('cases-s');
        if (index_s != -1) {//if short is present
          return (index_s + 2);//short index + 2
        } else {
          return 0;
        }
      }
      if (value == 'REJ') {//rejected is selected
        const index_s = invoice.cHeader.indexOf('cases-s');//index of short_cases
        const index_d = invoice.cHeader.indexOf('cases-d');//index of damaged_cases
        if (index_s != -1 && index_d != -1) {
          return (index_d + 2);
        } else if (index_s == -1 && index_d != -1) {
          return index_d + 2;
        } else if (index_s != -1 && index_d == -1) {
          return index_s + 2;
        } else {
          return 0;
        }
      }

      if (value == 'CARTON_DMG') {
        const index_s = invoice.cHeader.indexOf('cases-s');//index of short_cases
        const index_d = invoice.cHeader.indexOf('cases-d');//index of damaged_cases
        const index_r = invoice.cHeader.indexOf('cases-r');//index of rejected_cases

        if ((index_s != -1 && index_d != -1 && index_r != -1)) {//all three exists
          return (index_r + 2);
        } else if ((index_s == -1 && index_d != -1 && index_r != -1) || (index_s != -1 && index_d == -1 && index_r != -1) || (index_s == -1 && index_d == -1 && index_r != -1)) {//!short & damaged & rejected
          return index_r + 2;
        } else if ((index_s != -1 && index_d != -1 && index_r == -1) || (index_s == -1 && index_d != -1 && index_r == -1)) {//short & damaged & !rejected
          return index_d + 2;
        } else if (index_s != -1 && index_d == -1 && index_r == -1) {//short & !damaged & !rejected
          return index_s + 2;
        } else if ((index_s == -1 && index_d == -1 && index_r == -1)) {//!short & !damaged & !rejected
          return 0;
        }
      }
    }

  }

  //calculate the subHeader index
  calculateSubIndex(value, invoice, type = 1) {
    if (type) {
      if (value == "SRT") {
        if (invoice.subHeader.length) {
          invoice.subHeader.splice(1, 0, 'header-row-second-group');
        } else {
          invoice.subHeader.splice(0, 0, 'header-row-first-group', 'header-row-second-group');
        }
      }
      if (value == "DMG") {
        if (invoice.subHeader.length) {
          const exists = invoice.subHeader.includes('header-row-second-group');
          if (exists) {
            invoice.subHeader.splice(2, 0, 'header-row-third-group');
          } else {
            invoice.subHeader.splice(1, 0, 'header-row-third-group');
          }
        } else {
          invoice.subHeader.splice(0, 0, 'header-row-first-group', 'header-row-third-group');
        }
      }
      if (value == "REJ") {
        if (invoice.subHeader.length) {
          const exists_s = invoice.subHeader.includes('header-row-second-group');
          const exists_d = invoice.subHeader.includes('header-row-third-group');
          if (exists_s && exists_d) {
            invoice.subHeader.splice(3, 0, 'header-row-fourth-group');
          } else if ((exists_s && !exists_d) || (!exists_s && exists_d)) {
            invoice.subHeader.splice(2, 0, 'header-row-fourth-group');
          } else {
            invoice.subHeader.splice(1, 0, 'header-row-fourth-group');
          }
        } else {
          invoice.subHeader.splice(0, 0, 'header-row-first-group', 'header-row-fourth-group');
        }
      }
      if (value == "CARTON_DMG") {
        if (invoice.subHeader.length) {
          const exists_s = invoice.subHeader.includes('header-row-second-group');
          const exists_d = invoice.subHeader.includes('header-row-third-group');
          const exists_r = invoice.subHeader.includes('header-row-fourth-group');

          // short & damaged & !rejected
          if (exists_s && exists_d && !exists_r) {
            invoice.subHeader.splice(3, 0, 'header-row-fifth-group');
          } else if (exists_s && !exists_d && exists_r) { // short & !damaged & rejected
            invoice.subHeader.splice(3, 0, 'header-row-fifth-group');
          } else if (!exists_s && exists_d && exists_r) { // !short & damaged & rejected
            invoice.subHeader.splice(3, 0, 'header-row-fifth-group');
          } else if (!exists_s && !exists_d && exists_r) { // !short & !damaged & rejected
            invoice.subHeader.splice(2, 0, 'header-row-fifth-group');
          } else if (!exists_s && exists_d && !exists_r) { // !short & damaged & !rejected
            invoice.subHeader.splice(2, 0, 'header-row-fifth-group');
          } else if (exists_s && !exists_d && !exists_r) { // short & !damaged & !rejected
            invoice.subHeader.splice(2, 0, 'header-row-fifth-group');
          } else if (exists_s && exists_d && exists_r) { // short & damaged & rejected
            invoice.subHeader.splice(4, 0, 'header-row-fifth-group');
          } else if (!exists_s && !exists_d && !exists_r) {// !short & !damaged & !rejected
            invoice.subHeader.splice(1, 0, 'header-row-fifth-group');
          }
        } else {
          invoice.subHeader.splice(0, 0, 'header-row-first-group', 'header-row-fifth-group');
        }
      }
    } else {
      if (value == "SRT") {
        if (invoice.subHeader.length) {
          invoice.subHeader.splice(1, 0, 'header-row-second-group');
        } else {
          invoice.subHeader.splice(0, 0, 'header-row-second-group');
        }
      }
      if (value == "DMG") {
        if (invoice.subHeader.length) {
          const exists = invoice.subHeader.includes('header-row-second-group');
          if (exists) {
            invoice.subHeader.splice(2, 0, 'header-row-third-group');
          } else {
            invoice.subHeader.splice(1, 0, 'header-row-third-group');
          }
        } else {
          invoice.subHeader.splice(0, 0, 'header-row-third-group');
        }
      }
      if (value == "REJ") {
        if (invoice.subHeader.length) {
          const exists_s = invoice.subHeader.includes('header-row-second-group');
          const exists_d = invoice.subHeader.includes('header-row-third-group');
          if (exists_s && exists_d) {
            invoice.subHeader.splice(3, 0, 'header-row-fourth-group');
          } else if ((exists_s && !exists_d) || (!exists_s && exists_d)) {
            invoice.subHeader.splice(2, 0, 'header-row-fourth-group');
          } else {
            invoice.subHeader.splice(1, 0, 'header-row-fourth-group');
          }
        } else {
          invoice.subHeader.splice(0, 0, 'header-row-fourth-group');
        }
      }
      if (value == "CARTON_DMG") {
        if (invoice.subHeader.length) {
          const exists_s = invoice.subHeader.includes('header-row-second-group');
          const exists_d = invoice.subHeader.includes('header-row-third-group');
          const exists_r = invoice.subHeader.includes('header-row-fourth-group');

          // short & damaged & !rejected
          if (exists_s && exists_d && !exists_r) {
            invoice.subHeader.splice(3, 0, 'header-row-fifth-group');
          } else if (exists_s && !exists_d && exists_r) { // short & !damaged & rejected
            invoice.subHeader.splice(3, 0, 'header-row-fifth-group');
          } else if (!exists_s && exists_d && exists_r) { // !short & damaged & rejected
            invoice.subHeader.splice(3, 0, 'header-row-fifth-group');
          } else if (!exists_s && !exists_d && exists_r) { // !short & !damaged & rejected
            invoice.subHeader.splice(2, 0, 'header-row-fifth-group');
          } else if (!exists_s && exists_d && !exists_r) { // !short & damaged & !rejected
            invoice.subHeader.splice(2, 0, 'header-row-fifth-group');
          } else if (exists_s && !exists_d && !exists_r) { // short & !damaged & !rejected
            invoice.subHeader.splice(2, 0, 'header-row-fifth-group');
          } else if (exists_s && exists_d && exists_r) { // short & damaged & rejected
            invoice.subHeader.splice(4, 0, 'header-row-fifth-group');
          } else if (!exists_s && !exists_d && !exists_r) {// !short & !damaged & !rejected
            invoice.subHeader.splice(1, 0, 'header-row-fifth-group');
          }
        } else {
          invoice.subHeader.splice(0, 0, 'header-row-fifth-group');
        }
      }
    }

  }


  updateCWS(id, index) {
    const request = {
      CWB_id: id,
      CWB_no: this.newLRValue
    };
    this.showLoader = true;
    this.http.post('shipment/update_waybill', request).subscribe(
      (response: any) => {
        this.showLoader = false;
        if (response.statusCode == 200) {
          this.snackbar.openSnackBar('LR Updated');
          this.shipment.lorry_receipt[index].CWB.manual = response.data.CWB.manual;
          this.shipment.lorry_receipt[index].consignee_copy = response.data.consignee_copy;
          this.shipment.lorry_receipt[index].consignor_copy = response.data.consignor_copy;
          this.shipment.lorry_receipt[index].driver_copy = response.data.driver_copy;
          this.shipment.lorry_receipt[index].file_copy = response.data.file_copy;
          this.shipment.lorry_receipt[index].pdf_link = response.data.pdf_link;
          this.shipment.lorry_receipt[index]._id = response.data._id;
          this.newLRValue = '';
          this.editLRID = '';
        }
      },
      (err => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      })
    );
  }

  // get arrival time of shipment
  getShipmentData() {
    this.shipment_data = [];
    // push arrival times of pickups
    this.shipment.pickups.forEach((e, index) => {
      const shipment: any = {};
      shipment.name = 'P' + (index + 1);
      shipment.value = shipment.name;
      if (e.arrived_at) {
        shipment.arrived_at = e.arrived_at;
        shipment.xAxis = this.timeService.toShortDateTime(shipment.arrived_at, 'dd/MMM/yyyy hh:mm a');
        this.shipment_data.push(shipment);
      }
    });

    // push arrival times of deliveries
    this.shipment.deliveries.forEach((e, index) => {
      const shipment: any = {};
      shipment.name = 'D' + (index + 1);
      shipment.value = shipment.name;
      if (e.arrived_at) {
        shipment.arrived_at = e.arrived_at;
        shipment.xAxis = this.timeService.toShortDateTime(shipment.arrived_at, 'dd/MMM/yyyy hh:mm a');
        this.shipment_data.push(shipment);
      }
    });
  }

  // get temperature at arrival time
  getTemperature() {
    this.chartData.forEach((item, index) => {
      this.shipment_data.forEach((shipment) => {
        const diff = this.timeService.findDiff(item.timestamp, shipment.arrived_at);
        if (Math.abs(diff.days) == 0 && Math.abs(diff.hours) == 0 && Math.abs(diff.minutes) <= 2 && Math.abs(diff.seconds) <= 60) {
          shipment.xAxis = index;
          shipment.yAxis = item.value;
        }
      });
    });
    this.shipment_data = this.shipment_data.map((data) => {
      return {
        name: data.name,
        value: data.name,
        xAxis: data.xAxis,
        yAxis: data.yAxis,
        symbol: 'pin',
        label: {
          show: true
        }
      };
    });
  }

  placePickupsDrops(shipment) {
    if (this.mapMarkers.length) {
      this.removeMarkers(this.mapMarkers);
    }
    const from = shipment.pickups;
    const to = shipment.deliveries;
    const bounds = new google.maps.LatLngBounds();

    from.forEach((e, i) => {
      this.placeMarker(e.location.geo_point.coordinates, 'P' + (i + 1), this.picon);
      const latLng = {
        lat: e.location.geo_point.coordinates[1],
        lng: e.location.geo_point.coordinates[0]
      };
      bounds.extend(latLng);
      this.map.fitBounds(bounds);
    });
    to.forEach((e, i) => {
      this.placeMarker(e.location.geo_point.coordinates, 'D' + (i + 1), this.dicon);
      const latLng = {
        lat: e.location.geo_point.coordinates[1],
        lng: e.location.geo_point.coordinates[0]
      };
      bounds.extend(latLng);
      this.map.fitBounds(bounds);

    });
  }

  toShortDateTime(value) {
    return (value) ? this.timeService.toShortDateTime(value) : 'N/A';
  }

  toTime(value) {
    return (value) ? this.timeService.toTime(value) : 'N/A';
  }
  getFreightInvoices(shipment_id) {
    this.showLoader = true;
    this.http.get('carrier_invoice/by_shipment?shipment_id=' + shipment_id, '', 1).subscribe(
      (response: any) => {
        this.showLoader = false;
        if (response.data.length) {
          if (response.data[0].new_flow == true) {
            this.isNewFlow = true;
          }
          this.regenFreightData = response.data;
          response.data.map(e => {
            const temp: any = {};

            temp.version_id = e.unique_code;
            temp.invoiceNo = e.IINC.custom ? e.IINC.custom : e.IINC.default;
            temp.datetime = this.timeService.toShortDateTime(e.created_at);
            temp.updated_by = e.carrier_user.name || 'N/A';
            temp.final_amount = e.final_amount;
            temp.status = e.status;
            temp.pdf_link = e.pdf_link;
            temp.comment = e.comments || 'N/A';
            temp.view = '';
            temp.edit = '';
            temp.shipment = e.shipment;
            temp.disDoc = e.disapprove_doc;
            temp.custom_invoice = e.custom_invoice;
            temp.custom_invoice_number = e.IINC.custom ? e.IINC.custom : '';
            temp.pdf_links = e.pdf_links;
            temp.new_flow = e.new_flow;
            if (e.new_flow == true) {
              temp.line_items = e.GST_id.line_items;
              temp.deductibles = e.GST_id.deductibles;
            }
            // console.log("something",{e});
            if(e.custom_reference_date){
              this.referenceDate = e.custom_reference_date;
            }

            this.freightInvoices.push(temp);
          });
        }
        if (this.freightInvoices.length > 0)
          this.isCarrierInvoiceDisabled = true;

        if (!this.URD && !this.GTAtoGTA) {
          this.shipment.payment_details = (this.parentData.constants && this.parentData.constants.payment) ? this.parentData.constants.payment : '';
          if (this.shipment.payment_details.tax_details) {
            this.shipment.no_taxid_gst = (!this.shipment.payment_details.tax_details.GSTIN && !this.shipment.payment_details.tax_details.tax_id_3);
          } else {
            this.shipment.no_taxid_gst = true;
          }
        }

        // disable Generate Freight button if already approved
        if (this.parentData.latest_status == 'CPTD' || this.parentData.latest_status == 'CNCL') {
          if (!this.shipment.billing_address) {
            this.disableGenerateInvoice = false;
            this.warning_message = this.translation.instant('MESSAGE.SHIPMENT_DETAILS.FREIGHT.VALIDATION.WARNING_BILLING_ADDRESS');
            this.hint_message = this.translation.instant('MESSAGE.SHIPMENT_DETAILS.FREIGHT.VALIDATION.HINT_BILLING_ADDRESS');
          } else if (this.shipment.no_taxid_gst && this.country == 'IN') {
            this.disableGenerateInvoice = false;
            this.warning_message = this.translation.instant('MESSAGE.SHIPMENT_DETAILS.FREIGHT.VALIDATION.WARNING_GST_TAXID');
            this.hint_message = this.translation.instant('MESSAGE.SHIPMENT_DETAILS.FREIGHT.VALIDATION.HINT_GST_TAXID');
          }
          if (!this.warning_message) {
            if ((this.freightInvoices.length && this.freightInvoices[0].status != 'DISAPPROVED')) {
              this.disableGenerateInvoice = false;
            } else if (this.freightInvoices.length && this.freightInvoices[0].status == 'DISAPPROVED') {
              this.disableGenerateInvoice = true;
              this.regenerateInvoice = true;
            } else {
              this.disableGenerateInvoice = true;
            }
          }

        }
      },
      (err) => {
        this.showLoader = false;
      }
    );
  }

  showGenerateInvoice() {
    this.isNewFlow = false;
    this.cancelGenerate = false;

    this.clearFreightGeneration();

    if (!this.regenerateInvoice) {
      this.showGenerateFreight = true;
      this.updateFreight = false;
      this.initFreight();
    } else {
      this.showGenerateFreight = true;
      this.initRegenerateFreight(0);
    }
  }

  showGenerateInvoiceNew() {

    this.isNewFlow = true;
    this.cancelGenerate = false;
    this.showGenerateFreight = true;

    this.clearFreightGenerationNew();

    // this.newCarrierInvoiceArray = [];
    // this.newDeductibleChargeArray = [];
    // this.totalPreTaxAmount = 0;
    // this.totalTaxAmount = 0;
    // this.totalCharges = 0;
    this.gstID = "";

    this.addCarrierInvoiceRow();
    this.addDeductibleChargeRow();
  }



  clearFreightGeneration() {
    this.freightData = {
      shipment_id: '',
      amount_from: {},
      discount: {},
      ref_lr_id: '',
      // ref_lr_type: '',
      additional_charges: {
        labour: { // Porter
          value: 0,
          comment: ''
        },
        doc: { // Document Charges
          value: 0,
          comment: ''
        },
        toll: { // Toll
          value: 0,
          comment: ''
        },
        non_hometown_halt: {
          value: 0,
          comment: ''
        },
        insurance: { // Insurance
          value: 0,
          comment: ''
        },
        cancellation: { // Cancellation
          value: 0,
          comment: ''
        },
        detentionCustomer: { 
          value: 0,
          comment: ''
        },
        detentionPlant: {
          value: 0,
          comment: ''
        },
        extra_pickup: {
          value: 0,
          comment: ''
        },
        extra_delivery: {
          value: 0,
          comment: ''
        },
        LR_charges: {
          value: 0,
          comment: ''
        },
        others: {
          value: 0,
          comment: ''
        },
        green_tax: {
          value: 0,
          comment: ''
        },
        odc_charges: {
          value: 0,
          comment: ''
        },
        rto_fines: {
          value: 0,
          comment: ''
        },
        unloading_charges: {
          value: 0,
          comment: ''
        },
        loading_charges: {
          value: 0,
          comment: ''
        }
      },
      deductible_charges: {
        material_damage: { // Material damaged penalty
          value: 0,
          comment: ''
        },
        material_missing: { // material missing Penalty
          value: 0,
          comment: ''
        },
        vehicle_delay: {//transit delay
          value: 0,
          comment: ''
        },
        carton_damage: {//carton damage
          value: 0,
          comment: ''
        },
        shipper_LR_charges: {// Shipper LR charges
          value: 0,
          comment: ''
        },
        others: {//others
          value: 0,
          comment: ''
        }
      },
      custom_invoice: false,
      custom_invoice_number: '',
    };

    this.comments = "";
    this.reference_no = '';
    this.ref_lr_id = '';
    this.customInvoiceNumber = "";
  }
  clearFreightGenerationNew() {

    this.newCarrierInvoiceArray = [];
    this.newDeductibleChargeArray = [];
    this.totalPreTaxAmount = 0;
    this.totalTaxAmount = 0;
    this.totalCharges = 0;
    this.reference_no = '';
    this.ref_lr_id = '';
    this.comments = "";
    this.customInvoiceNumber = "";
  }

  cancelFreightGeneration() {
    this.cancelGenerate = true;
    if (this.updateFreight) {
      if (this.regenerateInvoice) {
        this.disableGenerateInvoice = true;
      } else {
        this.disableGenerateInvoice = false;
      }
    } else {
      this.disableGenerateInvoice = true;
    }
    this.showGenerateFreight = false;
    this.initFreight();
  }
  cancelFreightGenerationNew() {

    this.cancelGenerate = true;
    if (this.updateFreight) {
      if (this.regenerateInvoice) {
        this.disableGenerateInvoice = true;
      } else {
        this.disableGenerateInvoice = false;
      }
    } else {
      this.disableGenerateInvoice = true;
    }
    this.showGenerateFreight = false;
  }

  initFreight() {
    // console.log('call');
    this.discountSelected.name = this.discountTypes[0].name;
    this.discountSelected.value = this.discountTypes[0].value;
    this.freightData.shipment_id = this.parentData._id;
    //estimated price
    if (this.parentData.estimated) {
      //estimated client price / client price per weight
      if (this.parentData.estimated.price) {
        this.freightamount.estimated = this.parentData.estimated.price;
      } else if (this.parentData.estimated.price_per_weight) {
        this.freightamount.estimated = this.parentData.estimated.price_per_weight;
      } else {
        this.freightamount.estimated = 0;
      }
      this.freightData.amount_from = {
        type: 'estimated',
        comment: '',
      };
      this.freightType = 0;
    } else {
      this.freightamount.estimated = 0;
    }

    //actual price
    if (this.parentData.actual) {
      //actual price
      if (this.parentData.actual.price) {
        this.freightamount.actual = this.parentData.actual.price;
      } else {
        this.freightamount.actual = 0;
      }
      this.freightData.amount_from = {
        type: 'actual',
        comment: '',
      };
      this.freightType = 1;
    } else {
      this.freightamount.actual = 0;
    }
    //console.log('very');
    //console.log(this.freightamount.actual);

    // if (this.parentData.actual && this.parentData.actual.price) {
    //   this.freightamount.actual = this.parentData.actual.price;
    //   this.freightData.amount_from = {
    //     type: 'actual',
    //     comment: '',
    //   };
    //   this.freightType = 1;
    // } else {
    //   this.freightData.amount_from = {
    //     type: 'estimated',
    //     comment: '',
    //   };
    // }
    // (this.parentData.estimated && this.parentData.estimated.price) ? this.freightamount.estimated = this.parentData.estimated.price : '';
    this.freightData.discount = {
      percentage: 0,
      amount: 0,
      comment: ''
    };
    this.otherChargesTotal = 0;
    this.discountTotal = 0;
    if (!this.cancelGenerate) {
      this.freightData.ref_lr_id = '';
      if (this.parentData.carrier_waybills && this.parentData.carrier_waybills.length) {
        this.parentData.carrier_waybills.forEach((waybill, index) => {
          const lrnum = waybill.CWB.manual ? waybill.CWB.manual : (waybill.CWB.custom ? waybill.CWB.custom : waybill.CWB.default);
          const comma = (index + 1 == this.parentData.carrier_waybills.length) ? '' : ',';
          this.freightData.ref_lr_id += lrnum + comma; // Unique Number
        });
      }
    }

    // this.freightData.ref_lr_type = '';

    this.freightData.deductible_charges = {
      material_damage: { // Material damaged penalty
        value: this.parentData.material_damage_deduction ? this.parentData.material_damage_deduction : 0,
        comment: ''
      },
      material_missing: { // material missing Penalty
        value: this.parentData.material_missing_deduction ? this.parentData.material_missing_deduction : 0,
        comment: ''
      },
      vehicle_delay: {//transit delay
        value: this.parentData.actual_delay_deduction ? this.parentData.actual_delay_deduction : 0,
        comment: this.parentData.actual_delay_deduction ? 'Transit Delay' : ''
      },
      carton_damage: {//carton damage
        value: this.parentData.carton_damage_deduction ? this.parentData.carton_damage_deduction : 0,
        comment: ''
      },
      shipper_LR_charges: {// Shipper LR charges
        value: this.parentData.shipper_LR_charge ? this.parentData.shipper_LR_charge : 0,
        comment: ''
      },
      others: {//others
        value: 0,
        comment: ''
      }
    }
    if (this.shipment.detentionCustomer) this.freightData.additional_charges.detentionCustomer.value = this.shipment.detention_charges_customer;
    if (this.shipment.detentionPlant) this.freightData.additional_charges.detentionPlant.value = this.shipment.detention_charges_plant;

    this.calcOtherCharges();

    //console.log('initFreight');
    this.calcDeductibleCharges();
    this.calculateTotalValue();
  }

  initRegenerateFreight(i) {

    // console.log('initRegenerateFreight');
    this.updateFreight = true;
    this.freightData = {
      shipment_id: '',
      amount_from: {},
      discount: {},
      ref_lr_id: '',
      // ref_lr_type: '',
      additional_charges: {},
      deductible_charges: {}
    };
    // console.log("freight data", this.regenFreightData)
    this.URD = this.regenFreightData[i].URD;
    this.GTAtoGTA = this.regenFreightData[i].GTAtoGTA;
    this.tax_type = this.regenFreightData[i].tax_type;
    this.reference_no = this.regenFreightData[i].ref_number ? this.regenFreightData[i].ref_number : '';
    this.e_invoice_bill = this.regenFreightData[i].e_invoice_bill ? this.regenFreightData[i].e_invoice_bill : '';
    this.e_invoice_qr_code = this.regenFreightData[i].e_invoice_qr_code ? this.regenFreightData[i].e_invoice_qr_code : '';
    this.customInvoice = this.regenFreightData[i].custom_invoice;
    if (this.customInvoice) this.customInvoiceNumber = this.regenFreightData[i].IINC.custom ? this.regenFreightData[i].IINC.custom : '';
    this.freightData.shipment_id = this.regenFreightData[i].shipment._id;
    if (this.regenFreightData[i].discount) {
      this.discountAmount.comment = this.regenFreightData[i].discount.comment ? this.regenFreightData[i].discount.comment : this.discountAmount.comment;
      this.discountAmount.percentage = this.regenFreightData[i].discount.percentage ? this.regenFreightData[i].discount.percentage : this.discountAmount.percentage;
      this.discountAmount.amount = this.regenFreightData[i].discount.amount ? this.regenFreightData[i].discount.amount : this.discountAmount.amount;
      if (this.discountAmount.percentage) {
        this.discountSelected.value = 'percentage';
        this.discountSelected.name = 'Percentage';
      } else {
        this.discountSelected.value = 'amount',
          this.discountSelected.name = 'Amount';
      }
      this.discountTotal = this.regenFreightData[i].discount.amount ? this.regenFreightData[i].discount.amount : 0;
    }
    this.freightData.additional_charges = this.regenFreightData[i].additional_charges;
    if (!this.freightData.additional_charges.detentionCustomer) {
        this.freightData.additional_charges.detentionCustomer = {value: 0};
    }
    if (!this.freightData.additional_charges.detentionPlant) {
        this.freightData.additional_charges.detentionPlant = {value: 0};
    }
    this.freightData.deductible_charges = this.regenFreightData[i].deductible_charges ? this.regenFreightData[i].deductible_charges : {};
    if (this.shipment.detentionCustomer) this.freightData.additional_charges.detentionCustomer.value = this.shipment.detention_charges_customer;
    if (this.shipment.detentionPlant) this.freightData.additional_charges.detentionPlant.value = this.shipment.detention_charges_plant;
    this.otherChargesTotal = this.regenFreightData[i].total_additional_charges;
    this.deductibleChargesTotal = this.regenFreightData[i].total_deductible_charges;
    this.freightSubTotal = this.regenFreightData[i].sub_total;
    this.totalAmount = this.regenFreightData[i].final_amount;
    this.netPayableAmount = this.regenFreightData[i].net_payable_amount ? this.regenFreightData[i].net_payable_amount : 0;
    this.freightData.amount_from.type = 'estimated'; // TODO: get this from backend
    this.freightType = 0; // TODO: get this from backend
    this.freightamount.estimated = this.regenFreightData[i].initial_amount.value;
    this.freightData.ref_lr_id = '';
    if (this.parentData.carrier_waybills && this.parentData.carrier_waybills.length) {
      this.parentData.carrier_waybills.forEach((waybill, index) => {
        const lrnum = waybill.CWB.manual ? waybill.CWB.manual : (waybill.CWB.custom ? waybill.CWB.custom : waybill.CWB.default);
        const comma = ((index + 1) == this.parentData.carrier_waybills.length) ? '' : ',';
        this.freightData.ref_lr_id += lrnum + comma; // Unique Number
      });
    }
    //other charges
    this.freightData.additional_charges.insurance.value = this.regenFreightData[i].additional_charges.insurance.value;
    this.freightData.additional_charges.cancellation.value = this.regenFreightData[i].additional_charges.cancellation.value;
    this.freightData.additional_charges.non_hometown_halt.value = this.regenFreightData[i].additional_charges.non_hometown_halt.value;
    this.freightData.additional_charges.extra_delivery.value = this.regenFreightData[i].additional_charges.extra_delivery.value;
    this.freightData.additional_charges.extra_pickup.value = this.regenFreightData[i].additional_charges.extra_pickup.value;
    this.freightData.additional_charges.toll.value = this.regenFreightData[i].additional_charges.toll.value;
    this.freightData.additional_charges.labour.value = this.regenFreightData[i].additional_charges.labour.value;
    this.freightData.additional_charges.doc.value = this.regenFreightData[i].additional_charges.doc.value;
    this.freightData.additional_charges.LR_charges.value = this.regenFreightData[i].additional_charges.LR_charges.value;
    this.freightData.additional_charges.detentionCustomer.value = this.regenFreightData[i].additional_charges.detentionCustomer.value;
    this.freightData.additional_charges.detentionPlant.value = this.regenFreightData[i].additional_charges.detentionPlant.value;
    if (this.freightData.additional_charges.others) {
      this.freightData.additional_charges.others.value = this.regenFreightData[i].additional_charges.others.value;
    }
    if (this.freightData.additional_charges.green_tax) {
      this.freightData.additional_charges.green_tax.value = this.regenFreightData[i].additional_charges.green_tax.value;
    } else {
      this.freightData.additional_charges.green_tax = {};
      this.freightData.additional_charges.green_tax.value = 0;
      this.freightData.additional_charges.green_tax.comment = '';
    }
    if (this.freightData.additional_charges.odc_charges) {
      this.freightData.additional_charges.odc_charges.value = this.regenFreightData[i].additional_charges.odc_charges.value;
    } else {
      this.freightData.additional_charges.odc_charges = {};
      this.freightData.additional_charges.odc_charges.value = 0;
      this.freightData.additional_charges.odc_charges.comment = '';
    }
    if (this.freightData.additional_charges.rto_fines) {
      this.freightData.additional_charges.rto_fines.value = this.regenFreightData[i].additional_charges.rto_fines.value;
    } else {
      this.freightData.additional_charges.rto_fines = {};
      this.freightData.additional_charges.rto_fines.value = 0;
      this.freightData.additional_charges.rto_fines.comment = '';
    }

    //deductible charges
    if (this.regenFreightData[i].deductible_charges) {
      this.freightData.deductible_charges.vehicle_delay.value = this.regenFreightData[i].deductible_charges.vehicle_delay ? this.regenFreightData[i].deductible_charges.vehicle_delay.value : 0;
      this.freightData.deductible_charges.material_damage.value = this.regenFreightData[i].deductible_charges.material_damage ? this.regenFreightData[i].deductible_charges.material_damage.value : 0;
      this.freightData.deductible_charges.material_missing.value = this.regenFreightData[i].deductible_charges.material_missing ? this.regenFreightData[i].deductible_charges.material_missing.value : 0;
      this.freightData.deductible_charges.carton_damage.value = this.regenFreightData[i].deductible_charges.carton_damage ? this.regenFreightData[i].deductible_charges.carton_damage.value : 0;
      this.freightData.deductible_charges.shipper_LR_charges.value = this.regenFreightData[i].deductible_charges.shipper_LR_charges ? this.regenFreightData[i].deductible_charges.shipper_LR_charges.value : 0;
      this.freightData.deductible_charges.others.value = this.regenFreightData[i].deductible_charges.others ? this.regenFreightData[i].deductible_charges.others.value : 0;
    }

    this.freightData.invoice_id = this.regenFreightData[i]._id;
    this.tollCharge = this.freightData.additional_charges.toll.value;
    this.greenTaxCharge = this.freightData.additional_charges.green_tax.value;
    this.calcOtherCharges();
    this.calcDeductibleCharges();
    this.calculateTotalValue();
    this.calculateGST();
  }
  initRegenerateFreightNew(i) {

    this.isNewFlow = true;
    this.updateFreight = true;
    this.freightData = {
      shipment_id: '',
      invoice_id: ''
    };

    this.newCarrierInvoiceArray = [];

    this.URD = this.regenFreightData[i].URD;
    this.GTAtoGTA = this.regenFreightData[i].GTAtoGTA;
    this.tax_type = this.regenFreightData[i].tax_type;
    this.reference_no = this.regenFreightData[i].ref_number ? this.regenFreightData[i].ref_number : '';
     this.e_invoice_bill = this.regenFreightData[i].e_invoice_bill
       ? this.regenFreightData[i].e_invoice_bill
       : "";
     this.e_invoice_qr_code = this.regenFreightData[i].e_invoice_qr_code
       ? this.regenFreightData[i].e_invoice_qr_code
       : "";
    this.customInvoice = this.regenFreightData[i].custom_invoice;
    if (this.customInvoice) this.customInvoiceNumber = this.regenFreightData[i].IINC.custom ? this.regenFreightData[i].IINC.custom : '';
    this.totalPreTaxAmount = this.regenFreightData[i].GST_id.total_pre_tax_amount;
    this.totalTaxAmount = this.regenFreightData[i].GST_id.total_tax_amount;
    this.totalCharges = this.regenFreightData[i].GST_id.total_amount;
    this.gstID = this.regenFreightData[i].GST_id._id;
    this.comments = this.regenFreightData[i].comments;

    this.freightData.shipment_id = this.regenFreightData[i].shipment._id;
    this.freightData.invoice_id = this.regenFreightData[i]._id;

    this.regenFreightData[i].GST_id.line_items.forEach((carrier) => {
      const temp: any = {};
      temp.service_desc = carrier.service_desc;
      temp.party_name = carrier.party_name;
      temp.carrier_date = carrier.date;
      const _date: any = DateTime.fromFormat(carrier.date, 'dd-MMM-yyyy').startOf('day').toUTC();
      temp.date = _date.ts;
      temp.hsn_code = carrier.hsn_code;
      temp.sac_code = carrier.sac_code;
      temp.quantity = carrier.quantity;
      temp.weight = carrier.weight;
      temp.pre_tax = carrier.pre_tax;
      temp.ref = carrier.ref;
      this.newCarrierInvoiceArray.push(temp);
    });

    // this.newCarrierInvoiceArray=this.regenFreightData[i].GST_id.line_items;
    this.newDeductibleChargeArray = this.regenFreightData[i].GST_id.deductibles;
    this.carrierInvoiceArray = new MatTableDataSource(this.newCarrierInvoiceArray);
    this.deductibleChargeArray = new MatTableDataSource(this.newDeductibleChargeArray);

  }
  calcOtherCharges() {
    this.otherChargesTotal = 0;
    this.greenTaxCharge = 0;
    this.tollCharge = 0;
    for (const [name, item] of Object.entries(this.freightData.additional_charges)) {
      const temp: any = item;
      if (temp.value !== '') {
        if (parseFloat(temp.value) < 0) {
          this.snackbar.openSnackBar(this.translation.instant('MESSAGE.SHIPMENT_DETAILS.FREIGHT.VALIDATION.OTHER_CHARGES'), '', 'err');
          temp.value = 0;
          this.otherChargesTotal += parseFloat(temp.value);
        } else {
          if (name == 'penalty') {
            this.otherChargesTotal -= parseFloat(temp.value);
          } else if (temp.value) {
            this.otherChargesTotal += parseFloat(temp.value);
          }
        }
        if (name == 'toll' && temp.value) {
          this.tollCharge = parseFloat(temp.value);
        }
        else if (name == 'green_tax' && temp.value) {
          this.greenTaxCharge = parseFloat(temp.value);
        }
      }
    }
    this.calcDiscount();
    this.calculateTotalValue();
  }

  calcDeductibleCharges() {
    this.deductibleChargesTotal = 0;

    for (const [name, item] of Object.entries(this.freightData.deductible_charges)) {
      const temp: any = item;
      if (temp.value !== '') {
        if (parseFloat(temp.value) < 0) {
          this.snackbar.openSnackBar(this.translation.instant('MESSAGE.SHIPMENT_DETAILS.FREIGHT.VALIDATION.OTHER_CHARGES'), '', 'err');
          temp.value = 0;
          this.deductibleChargesTotal += parseFloat(temp.value);
        } else {
          this.deductibleChargesTotal += parseFloat(temp.value);
        }
      }
    }
    // this.deductibleChargesTotal += this.advance_amount;
    this.calcDiscount();
    this.calculateTotalValue();
  }

  calcDiscount() {
    const fr = (this.freightType) ? this.freightamount.actual : this.freightamount.estimated;
    if (this.discountSelected.value == 'percentage') {
      if (this.discountAmount.percentage > 100 || this.discountAmount.percentage < 0) {
        this.snackbar.openSnackBar(this.translation.instant('MESSAGE.SHIPMENT_DETAILS.FREIGHT.VALIDATION.PERCENTAGE'), '', 'err');
        this.discountAmount.percentage = 0;
        this.discountTotal = (this.discountAmount.percentage * ((fr - this.deductibleChargesTotal) + this.otherChargesTotal)) / 100 || 0;
        this.discountTotal = parseFloat(this.discountTotal.toFixed(2));
      } else {
        this.discountTotal = (this.discountAmount.percentage * ((fr - this.deductibleChargesTotal) + this.otherChargesTotal)) / 100 || 0;
        this.discountTotal = parseFloat(this.discountTotal.toFixed(2));
      }
    } else if (this.discountSelected.value == 'amount') {
      if (this.discountAmount.amount < 0) {
        this.snackbar.openSnackBar(this.translation.instant('MESSAGE.SHIPMENT_DETAILS.FREIGHT.VALIDATION.AMOUNT'), '', 'err');
        this.discountAmount.amount = 0;
        this.discountTotal = this.discountAmount.amount || 0;
      } else {
        this.discountTotal = this.discountAmount.amount || 0;
      }
    }
    this.calculateTotalValue();
  }

  calculateTotalValue() {

    if (!isNaN(this.otherChargesTotal) && !isNaN(this.deductibleChargesTotal)) {
      const fr = (this.freightType) ? this.freightamount.actual : this.freightamount.estimated;
      this.freightSubTotal = ((fr - this.deductibleChargesTotal) + this.otherChargesTotal) - this.discountTotal;
      if (!this.URD && !this.GTAtoGTA) {
        this.vatAmount = (this.gst * Math.abs(this.freightSubTotal - (this.tollCharge + this.greenTaxCharge))) / 100;
      } else {
        this.vatAmount = 0;
      }
      this.freightTotal = (this.freightSubTotal + this.vatAmount);
      this.freightSubTotal = parseFloat(this.freightSubTotal.toFixed(2));
      this.vatAmount = parseFloat(this.vatAmount.toFixed(2));
      this.freightTotal = parseFloat(this.freightTotal.toFixed(2));
      if (this.tax_type == "FCM12") {
        this.totalAmount = this.freightSubTotal + this.vatAmount;
      } else if (this.tax_type == "FCM18") {
        this.totalAmount = this.freightSubTotal + this.vatAmount;
      } else {
        this.totalAmount = this.freightSubTotal;
      }
      this.netPayableAmount = this.totalAmount - this.advance_amount;
    }
  }

  twoDecimal(event) {
    event.target.value = (event.target.value.indexOf('.') >= 0) ? (event.target.value.substr(0, event.target.value.indexOf('.')) + event.target.value.substr(event.target.value.indexOf('.'), 3)) : event.target.value;
  }

  approveFreight() {
    const request = {
      shipment_id: this.parentData._id
    };
    this.http.post('carrier_invoice/approve', request, 1).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          this.snackbar.openSnackBar(this.messages.SHIPMENT_DETAILS.FREIGHT.SUCCESS.APPROVED);
          this.getFreightInvoices(request.shipment_id);
        }
      }
    );
  }

  setUniqueNoType(unique) {
    this.freightData.ref_lr_type = unique.value;
    this.uniqueNoType = unique;
  }

  setDiscountType(item) {
    this.discountSelected.name = item.name;
    this.discountSelected.value = item.value;
    this.discountTotal = 0;
    this.discountAmount = {
      percentage: 0,
      amount: 0
    };
    this.calcDiscount();
  }

  //open epod in new window
  openNewWindow(link) {
    let id = Math.random() * 100000;
    let image = new Image();
    image.src = link;
    const w = window.open("", link + id);
    w.document.write(image.outerHTML);
  }

  createFreight() {

    // this.initFreight();
    this.cancelGenerate = false;
    let url = 'carrier_invoice/create';
    if (this.updateFreight && !this.regenerateInvoice) {
      url = 'carrier_invoice/update';
      delete this.freightData.shipment_id;
    } else if (this.updateFreight && this.regenerateInvoice) {
      url = 'carrier_invoice/create';
      delete this.freightData.invoice_id;
    }
    this.freightData.ref_number = this.reference_no;

    this.freightData.e_invoice_bill = this.e_invoice_bill;

    this.freightData.e_invoice_qr_code = this.e_invoice_qr_code;


    if (!this.freightData.ref_number) {
      delete this.freightData.ref_number;
    }
    if (!this.freightData.e_invoice_bill) {
      delete this.freightData.e_invoice_bill;
    }if (!this.freightData.e_invoice_qr_code) {
      delete this.freightData.e_invoice_qr_code;
    }
    if (!this.freightData.ref_lr_id) {
      delete this.freightData.ref_lr_id;
    }

    this.showLoader = true;

    this.freightData.discount = {
      percentage: parseFloat(this.discountAmount.percentage),
      amount: parseFloat(this.discountAmount.amount),
    };
    if (this.discountAmount.comment) {
      this.freightData.discount.comment = this.discountAmount.comment;
    }

    if (!this.freightData.amount_from.comment) {
      delete this.freightData.amount_from.comment;
    }
    if (!this.valid.isEmpty(this.customInvoiceNumber)) {
      this.freightData.custom_invoice = true;
      this.freightData.custom_invoice_number = this.customInvoiceNumber;
    } else {
      delete this.freightData.custom_invoice;
      delete this.freightData.custom_invoice_number;
    }

    if (!this.freightData.additional_charges.detentionCustomer ) {
      this.freightData.additional_charges.detentionCustomer = { value: 0 };
    }
    if (!this.freightData.additional_charges.detentionPlant) {
      this.freightData.additional_charges.detentionPlant = { value:  0 };
    }

    for (const [name, item] of Object.entries(this.freightData.additional_charges)) {
      const temp: any = item;
      if (!temp.comment) {
        delete temp.comment;
      }
      if (temp.value == '') {
        temp.value = 0;
      }
    }
    for (const [name, item] of Object.entries(this.freightData.deductible_charges)) {
      const temp: any = item;
      if (!temp.comment) {
        delete temp.comment;
      }
      if (temp.value == '') {
        temp.value = 0;
      }
    }
    if(this.referenceDate){
      //sending date in iso instead of UTC
      // this.freightData.custom_reference_date = DateTime.fromJSDate(this.referenceDate).startOf("day").toUTC();
      this.freightData.custom_reference_date = new Date(this.referenceDate).toISOString();
    }
    this.http.post(url, this.freightData, 1).subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          this.showLoader = false;
          if (this.updateFreight) {
            this.snackbar.openSnackBar(this.translation.instant('MESSAGE.SHIPMENT_DETAILS.FREIGHT.SUCCESS.UPDATED'), '');
          } else {
            this.snackbar.openSnackBar(this.translation.instant('MESSAGE.SHIPMENT_DETAILS.FREIGHT.SUCCESS.GENERATED'), '');
          }
          this.closeDialog();
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  createFreightNew() {

    this.cancelGenerate = false;
    this.showLoader = true;
    const dataToSend: any = {
      shipment_id: this.parentData._id,
      invoice_id: this.freightData.invoice_id,
      GST_id: this.gstID,
      ref_number: this.reference_no,
      ref_lr_id : this.ref_lr_id,
      e_invoice_bill: this.e_invoice_bill,
      e_invoice_qr_code: this.e_invoice_qr_code,
      comments: this.comments,
      custom_invoice: true,
      custom_invoice_number: this.customInvoiceNumber
    };

    let url = 'v2/carrier_invoice/create';
    if (this.updateFreight && !this.regenerateInvoice) {
      url = 'v2/carrier_invoice/update';
      delete dataToSend.shipment_id;
    } else {
      url = 'v2/carrier_invoice/create';
      delete dataToSend.invoice_id;
    }

    if (!this.reference_no) {
      delete dataToSend.reference_no;
    }
    if (!this.e_invoice_bill) {
      delete dataToSend.e_invoice_bill;
    }
    if (!this.e_invoice_qr_code) {
      delete dataToSend.e_invoice_qr_code;
    }
    if (!this.comments) {
      delete dataToSend.comments;
    }
    if (this.valid.isEmpty(this.customInvoiceNumber)) {
      delete dataToSend.custom_invoice;
      delete dataToSend.custom_invoice_number;
    }
    // console.log('this',this.referenceDate);
    if(this.referenceDate){
      dataToSend.custom_reference_date = this.referenceDate;
    }
    this.http.post(url, dataToSend, 1).subscribe(
      (data: any) => {

        if (data.statusCode == 200) {
          this.showLoader = false;
          if (this.updateFreight) {
            this.snackbar.openSnackBar(this.translation.instant('MESSAGE.SHIPMENT_DETAILS.FREIGHT.SUCCESS.UPDATED'), '');
          } else {
            this.snackbar.openSnackBar(this.translation.instant('MESSAGE.SHIPMENT_DETAILS.FREIGHT.SUCCESS.GENERATED'), '');
          }
          this.closeDialog();
        }
      },
      (err: any) => {

        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  spiltInvoice() {
    this.cancelGenerate = false;
    this.showLoader = true;
    const dataToSend: any = {
      shipment_id: this.parentData._id,
      GST_id: this.gstID,
      ref_number: this.reference_no
    };
    if(this.referenceDate){
      dataToSend.custom_reference_date = DateTime.fromJSDate(this.referenceDate).startOf('day').toUTC();
    }
    if (dataToSend.GST_id) {
      let url = 'v1/carrier_invoice/split_invoice';
      this.http.post(url, dataToSend, 1).subscribe(
        (data: any) => {
  
          if (data.statusCode == 200) {
            this.showLoader = false;
            if (this.updateFreight) {
              this.snackbar.openSnackBar(this.translation.instant('MESSAGE.SHIPMENT_DETAILS.FREIGHT.SUCCESS.UPDATED'), '');
            } else {
              this.snackbar.openSnackBar(this.translation.instant('MESSAGE.SHIPMENT_DETAILS.FREIGHT.SUCCESS.GENERATED'), '');
            }
            this.closeDialog();
          }
        },
        (err: any) => {
  
          this.showLoader = false;
          this.snackbar.openSnackBar(err.error.message, '', 'err');
        }
      );
    } else {
      this.showLoader = false;
      this.snackbar.openSnackBar(this.translation.instant('Please Calculate First'), '', 'err');
    }
  }
  formatTime(time) {
    return this.time.toShortDateTime(time, 'dd/MM/yyyy');
  }
  getHoursandMinutes(seconds) {
    return this.timeService.daysFormat(seconds);
  }

  switchTab(tab: number) {
    this.tabIndex = tab;
    if (tab == 5) {
      this.initMap();
    }
    if (tab == 7) {
      this.getChartData();
    }
    if (tab == 6) {

      // this.getAdditionalChargesFields();
      this.getAdditionalCharges();

    }
  }

  getChartData() {
    this.showLoader = true;
    this.getShipmentData();
    this.http.get('shipment/temperature', { shipment: this.shipment._id }).subscribe(
      (response: any) => {
        this.showLoader = false;

        // chart data
        this.chartData = response.data ? response.data.map(e => ({ timestamp: e.timestamp, value: parseFloat(parseFloat(e.value).toFixed(2)) })) : [];
        // x axis data = time stamp
        const xData = response.data ? response.data.map((e) => {
          return this.timeService.toShortDateTime(e.timestamp, 'dd-MMM-yyyy hh:mm a');
        }) : [];
        this.getTemperature();
        this.chartData = this.chartData.map((data) => {
          return {
            timestamp: this.timeService.toShortDateTime(data.timestamp, 'dd/MMM/yyyy hh:mm a'),
            value: data.value
          };
        });

        const context = this;
        this.temperatureGraph = {
          title: {
            text: 'Temperature Graph'
          },
          tooltip: {
            trigger: 'axis',
            formatter(params: any) {
              params = params[0];
              return params.data.timestamp + ' - ' + params.data.value.toFixed(2) + ' °C';
            },
            axisPointer: {
              animation: true
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xData,
            axisLabel: {
              formatter(data) {
                return data;
              }
            }
          },
          yAxis: {
            type: 'value',
            boundaryGap: [0, '100%'],
            axisLabel: {
              formatter: '{value} °C'
            },
            splitLine: {
              show: false
            },
          },
          dataZoom: [{
            startValue: this.chartData[0].timestamp,
            textStyle: {
              fontWeight: 'bold',
              fontSize: 8
            }
          }, {
            type: 'inside'
          }],
          series: [{
            name: 'Temperature',
            type: 'line',
            showSymbol: false,
            hoverAnimation: false,
            data: context.chartData,
            markPoint: {
              data: context.shipment_data,
            }
          }]
        };
      },
      (err: any) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  showInvoices(row) {
    console.log(row);
  }

  closeDialog() {
    if (this.disableGenerateInvoice) {
      this.dialog.close(this.disableGenerateInvoice);
    } else {
      this.dialog.close();
    }
  }

  requestEPODs(deliveryId) {
    this.showLoader = true;
    const dataToSend: any = {
      shipment: this.shipment._id,
      delivery: deliveryId
    };
    this.http.post('ws/shipment/request_epod', dataToSend).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          this.showLoader = false;
          this.snackbar.openSnackBar(this.messages.SHIPMENT_DETAILS.EPODS.SUCCESS.REQUEST_EPOD, '');
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }

  selectPODs(id, index) {
    this.uploadEpodData.index = index;
    this.uploadEpodData.delivery = id;
    document.getElementById('epods').click();
  }

  fileChanged(event: any, type: any, item: any) {
    if (event.target.files.length) {
      const formData: any = new FormData();

      if (type == 'epods') {

        formData.append('epod', event.target.files[0], event.target.files[0].name);
        formData.append('delivery', this.uploadEpodData.delivery);
        const dialogData = {
          name: 'Upload EPOD',
          text: this.translation.instant('MESSAGE.SHIPMENT_DETAILS.EPODS.SUCCESS.UPLOAD_EPOD'),
          dataToSend: formData,
          url: 'shipment/upload_epod' // TODO: get upload url
        };

        const dialogRef = this.dialogModal.open(ConfirmationModalComponent, {
          data: dialogData
        });
        dialogRef.afterClosed().subscribe(result => {
          if ((result && result.statusCode == 200)) {
            // refresh epods after successful upload
            this.no_epods = false;
            this.shipment.deliveries[this.uploadEpodData.index].epods = (result.data && result.data.length) ? result.data.map(element => {
              return {
                extension: element.substr(element.lastIndexOf('.')).substr(1),
                link: element
              };
            }) : [];
            this.epod_warning = '';
          }
        });

      } else if (type == 'containerNo') {
        // TODO: api integration

        formData.append('image', event.target.files[0]);

        const dialogData = {
          name: 'Upload Container & Seal #',
          text: this.translation.instant('MESSAGE.SHIPMENT_DETAILS.EPODS.SUCCESS.UPLOAD_CSNO'),
          dataToSend: formData,
          url: 'v2/shipment/upload_csno/' + this.uploadContainerSealData.pickup
        };

        const dialogRef = this.dialogModal.open(ConfirmationModalComponent, {
          data: dialogData
        });
        dialogRef.afterClosed().subscribe(result => {
          if ((result && result.statusCode == 200)) {
            // refresh container# or seal# after successful upload
            this.shipment.pickups[this.uploadContainerSealData.index].other_docs = result.data;
          }
        });

      }
    }
  }

  uploadContainerSeal(id, index) {
    this.uploadContainerSealData.index = index;
    this.uploadContainerSealData.pickup = id;
    document.getElementById('containerNo').click();
  }

  initMap() {
    this.showLoader = true;
    this.http.get('/v1/shipment/path?shipment=' + this.parentData._id).subscribe(
      (data: any) => {
        this.showLoader = false;
        if (data.statusCode === 200) {
          if (data.data.sim.length) {
            const simData = data.data.sim;
            this.markers.sim = simData;
            // this.simMode = true;
          }
          if (data.data.app.length) {
            const appData = data.data.app;
            this.markers.app = appData;
            this.appMode = true;
          }
          if (data.data.gps.length) {
            const gpsData = data.data.gps;
            this.markers.gps = gpsData;
            this.gpsMode = true;
          }

          if (!this.appMode) {
            if (this.markers.sim.length) {
              this.simMode = true;
            } else if (this.markers.gps.length) {
              this.gpsMode = true;
            } else {
              this.appMode = this.simMode = this.gpsMode = false;
            }
          }
        }
        // if (!this.markers.sim.length && !this.markers.app.length && !this.markers.gps) {
        //   if (navigator.geolocation) {
        //     navigator.geolocation.getCurrentPosition((position) => {
        //         this.initialLocation = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
        //         this.map.setCenter(this.initialLocation);
        //     });
        // }
        // }
        this.placeAllFavMarkers();

      });

    this.map = new google.maps.Map(document.getElementById('pathMap'), {
      zoom: 12,
      mapTypeControl: true,
      scaleControl: false,
      streetViewControl: false,
      zoomControl: true,
      mapTypeControlOptions: {
        position: google.maps.ControlPosition.LEFT_BOTTOM
      }
    });
  }
  placeAllFavMarkers() {
    // if(this.mapMarkers){
    //   this.removeMarkers(this.mapMarkers);
    // }
    this.drawPath();
    // if (this.appMode) {
    //   this.markers.app.forEach((element, index) => {
    //     this.placeMarker(element.location, '', 'app');
    //   });
    // } else if (this.simMode) {
    //   this.markers.sim.forEach((element, index) => {
    //     this.placeMarker(element.location, '', 'sim');
    //   });
    // }
  }

  removeMarkers(markers) {
    markers.forEach(element => {
      element.setMap(null);
    });
  }

  drawPath() {
    this.locations = [];
    if (this.flightPath) {
      this.flightPath.setMap(null); // Clear polyline
      this.coordinates = [];
    }
    const bounds = new google.maps.LatLngBounds();
    if (this.appMode) {
      this.locations = [];
      this.markers.app.forEach(element => {
        const latLng = {
          lat: 0.0,
          lng: 0.0
        };
        latLng.lat = element.geo_point.coordinates[1];
        latLng.lng = element.geo_point.coordinates[0];
        const temp: any = {};
        temp.location = latLng;
        // temp.address = 'instavans bengaluru';
        temp.date = this.timeService.toShortDateTime(element.created_at);
        this.locations.push(temp);
        this.coordinates.push(latLng);
        bounds.extend(latLng);
      });
    } else if (this.simMode) {
      this.locations = [];
      this.markers.sim.forEach(element => {
        const latLng = {
          lat: 0.0,
          lng: 0.0
        };
        latLng.lat = element.geo_point.coordinates[1];
        latLng.lng = element.geo_point.coordinates[0];
        const temp: any = {};
        temp.location = latLng;
        // temp.address = 'instavans bengaluru';
        temp.date = this.timeService.toShortDateTime(element.created_at);
        this.locations.push(temp);
        this.coordinates.push(latLng);
        bounds.extend(latLng);
      });
    } else if (this.gpsMode) {
      this.locations = [];
      this.markers.gps.forEach(element => {
        const latLng = {
          lat: 0.0,
          lng: 0.0
        };
        latLng.lat = element.geo_point.coordinates[1];
        latLng.lng = element.geo_point.coordinates[0];
        const temp: any = {};
        temp.location = latLng;
        // temp.address = 'instavans bengaluru';
        temp.date = this.timeService.toShortDateTime(element.created_at);
        this.locations.push(temp);
        this.coordinates.push(latLng);
        bounds.extend(latLng);
        // this.showLoader = true;
        // this.http.get('v1/shipment/gps_path', {shipment_id: this.parentData._id}).subscribe((data: any) => {
        //   this.showLoader = false;
        //   this.path = data.data.polylines;
        //   this.src.lat = data.data.lastLocation[0];
        //   this.src.lng = data.data.lastLocation[1];
        //   this.plotPolyLine(this.path);
        // },
        // (err) => {
        //   this.showLoader = false;
        //   this.snackbar.openSnackBar(err.error.message, '', 'err');
        // });
      });
    }

    this.flightPath = new google.maps.Polyline({
      path: this.coordinates,
      geodesic: true,
      strokeColor: '#FF0000',
      strokeOpacity: 1.0,
      strokeWeight: 2
    });
    this.flightPath.setMap(this.map);
    this.map.fitBounds(bounds);

    // Place pickup drop points
    // this.placePikupsDrops(this.shipment);

    // Calculate estimated distance and time
    const src = this.coordinates[this.coordinates.length - 1];
    const destination = this.shipment.deliveries[this.shipment.deliveries.length - 1].location.geo_point.coordinates;
    this.getDistance(src, destination);
    //  else {
    //   const destination = this.shipment.deliveries[this.shipment.deliveries.length - 1].location.geo_point.coordinates;
    //   this.getDistance(this.src, destination);
    // }
    this.placePickupsDrops(this.shipment);

  }

  viewLocation(address) {
    if (this.green) {
      this.green.setMap(null);
    }
    this.green = new google.maps.Marker({
      position: { lat: address.location.lat, lng: address.location.lng },
      map: this.map,
      icon: {
        url: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png',
        scaledSize: new google.maps.Size(40, 40)
      }
    });
    this.map.setZoom(18);
    this.map.panTo(this.green.position);
    this.mapMarkers.push(this.green);
    this.green.setMap(this.map);
  }

  getDistance(p, d) {
    const contxt = this;
    const service = new google.maps.DistanceMatrixService();
    if (p && d.length) {
      service.getDistanceMatrix(
        {
          origins: [new google.maps.LatLng(p.lat, p.lng)],
          destinations: [new google.maps.LatLng(d[1], d[0])],
          travelMode: 'DRIVING',
          avoidHighways: false,
          avoidTolls: false,
        }, (distance, status) => {
          contxt.estimatedValues.estDistanceKms = (distance.rows[0].elements[0].distance) ? distance.rows[0].elements[0].distance.text : 'N/A';
          contxt.estimatedValues.estDistanceMts = (distance.rows[0].elements[0].distance) ? distance.rows[0].elements[0].distance.value : 'N/A';
          contxt.estimatedValues.estTime = (distance.rows[0].elements[0].duration) ? distance.rows[0].elements[0].duration.text : 'N/A';
        }
      );
    }

  }

  placeMarker(markers, label = '', icon) {
    const marker = new google.maps.Marker({
      position: { lat: markers[1], lng: markers[0] },
      map: this.map,
      label: {
        text: label,
        color: "#fff",
      },
      icon
    });

    this.mapMarkers.push(marker);
    marker.setMap(this.map);
  }

  plotPolyLine(data, strokeColor = '#FF0000') {
    let jsonData: any = {};
    data.forEach(element => {
      jsonData = {
        overview_polyline: {
          points: element
        }
      };
    });

    if (jsonData.overview_polyline) {
      const path = google.maps.geometry.encoding.decodePath(jsonData.overview_polyline.points);

      for (const p of path) {
        this.bounds.extend(p);
      }

      this.flightPath = new google.maps.Polyline({
        path,
        strokeColor,
        strokeWeight: 3,
        fillColor: '#FF0000',
      });

      this.flightPath.setMap(this.map);
      this.map.fitBounds(this.bounds);
    }
  }

  openModal(row) {
    const mapData: any = {
      driverLoc: row.driver_location,
      activity: row.activity,
      synopsisText: row.synopsisText,
      date: row.date,
      onlyMarkers: true,
      pickups: this.shipment.pickups,
      deliveries: this.shipment.deliveries
    };


    const dialogRef = this.dialogModal.open(MapModalComponent, {
      data: mapData,
    });
  }
  addNumbers(element, i) {
    if (!this.valid.isEmpty(this.containerSealNo.containerNo) && !this.valid.isEmpty(this.containerSealNo.sealNo)) {
      this.containerSealNo[i].pickup = element._id;
      this.http.post('shipment/add_numbers', this.containerSealNo[i]).subscribe(
        (data: any) => {
          if (data.statusCode === 200) {
            const temp: any = [];
            this.containerArray[i].push({
              containerNo: this.containerSealNo[i].container,
              sealNo: this.containerSealNo[i].seal,
              action: ''
            });
            this.snackbar.openSnackBar(this.messages.SHIPMENT_DETAILS.container, '');
          }
          this.containerArray[i] = [...this.containerArray[i]];
          this.containerSealNo[i].container = '';
          this.containerSealNo[i].seal = '';
        },
        (err: any) => {
          this.snackbar.openSnackBar(err.error.message, '', 'err');
        }
      );
    }
  }
  requestContainerSeal(element) {
    this.http.post('ws/shipment/request_container_seal', { pickup: element._id }).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.snackbar.openSnackBar(this.messages.SHIPMENT_DETAILS.success, '');
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );

  }
  accept(shipment) {
    const acceptData: any = {
      shipment_id: shipment._id,
      driver_id: shipment.driver._id
    };
    this.http.post('shipment/accept', acceptData).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {

          this.snackbar.openSnackBar(this.messages.SHIPMENT_DETAILS.success, '');
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  setDateTime(value) {
    if (value.date || value.time) {
      const t1: any = this.timeService.getDateFromTime(value.time, 'hh:mm a');
      const t2: any = DateTime.fromJSDate(value.date).toFormat('dd/MM/yyyy');

      const epoch: any = DateTime.fromFormat(t2, 'dd/MM/yyyy').plus({ hours: t1.c.hour, minutes: t1.c.minute });
      value.date_time = epoch.ts;
    }
  }
  editTime(item) {
    const payload: any = {
      isPickUp: true,
      id: item._id,
      time: {
        arrived_at: item.arrivalTime.date_time,
        finished_at: item.finishTime.date_time
      }
    };
    this.http.post('shipment/pick_drop_time', payload).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.snackbar.openSnackBar(this.messages.SHIPMENT_DETAILS.update, '');
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.mesage, '', 'err');
      }
    );
  }
  editDeliveryTime(item) {
    const payload: any = {
      isPickUp: false,
      id: item._id,
      time: {
        arrived_at: item.arrivalTime.date_time,
        finished_at: item.finishTime.date_time
      }
    };
    this.http.post('shipment/pick_drop_time', payload).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.snackbar.openSnackBar(this.messages.SHIPMENT_DETAILS.update, '');
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.mesage, '', 'err');
      }
    );
  }

  openInvoicePreview(element) {
    this.storage.setToLocalStorage('Invoice', JSON.stringify(element));
    this.route.navigateByUrl('preview');
  }
  preview(link) {
    this.route.navigateByUrl(link);
  }

  setTransitType() {
    this.http.get('carrier_invoice/check_gst?shipment_id=' + this.shipment._id, {}, 1).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.shipment.transit_type = data.data;
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    )
  }


  addCarrierInvoiceRow() {

    var cnt = this.newCarrierInvoiceArray.length;

    const temp: any = {};
    if (cnt == 0)
      temp.service_desc = 'freight_amount';
    else
      temp.service_desc = '';
    temp.hsn_code = '';
    temp.sac_code = this.parentData && this.parentData.constants && this.parentData.constants.sac_code; 
    temp.carrier_date = new Date();
    const _date: any = DateTime.local().startOf('day').toUTC();
    temp.date = _date.ts;
    temp.ref = '';
    temp.party_name = '';
    temp.quantity = '';
    temp.weight = '';
    if (cnt == 0)
      temp.pre_tax = this.parentData.actual && this.parentData.actual.price;
    else
      temp.pre_tax = '';

    this.newCarrierInvoiceArray.push(temp);
    this.carrierInvoiceArray = new MatTableDataSource(this.newCarrierInvoiceArray);

  }
  removeCarrierInvoiceRow(index) {
    this.newCarrierInvoiceArray.splice(index, 1);
    // this.searchLocArray.splice(index, 1);
    this.carrierInvoiceArray = new MatTableDataSource(this.newCarrierInvoiceArray);
    // this.districtsData.splice(index, 1);
  }
  addDeductibleChargeRow() {

    const temp: any = {};
    temp.service_desc = '';
    temp.value = '';

    this.newDeductibleChargeArray.push(temp);
    this.deductibleChargeArray = new MatTableDataSource(this.newDeductibleChargeArray);

  }
  removeDeductibleChargeRow(index) {
    this.newDeductibleChargeArray.splice(index, 1);
    // this.searchLocArray.splice(index, 1);
    this.deductibleChargeArray = new MatTableDataSource(this.newDeductibleChargeArray);
    // this.districtsData.splice(index, 1);
  }

  calculate() {


    const valid = this.validate();
    if (valid) {

      const request = {
        shipment_id: this.parentData._id,
        line_items: [],
        deductibles: []
      };

      this.newCarrierInvoiceArray.forEach((carrier) => {
        const temp: any = {};
        temp.service_desc = carrier.service_desc;
        temp.pre_tax = carrier.pre_tax;

        if (!this.valid.isEmpty(carrier.party_name))
          temp.party_name = carrier.party_name;
        if (!this.valid.isEmpty(carrier.date))
          temp.date = carrier.date;
        if (!this.valid.isEmpty(carrier.hsn_code))
          temp.hsn_code = carrier.hsn_code;
        if (!this.valid.isEmpty(carrier.sac_code))
          temp.sac_code = carrier.sac_code;
        if (!this.valid.isEmpty(carrier.quantity))
          temp.quantity = carrier.quantity;
        if (!this.valid.isEmpty(carrier.weight))
          temp.weight = carrier.weight;
        if (!this.valid.isEmpty(carrier.ref))
          temp.ref = carrier.ref;

        request.line_items.push(temp);
      });

      this.newDeductibleChargeArray.forEach((carrier) => {
        const temp: any = {};
        temp.service_desc = carrier.service_desc;
        temp.value = carrier.value;
        if (!this.valid.isEmpty(temp.value))
          request.deductibles.push(temp);
      });

      this.http.post('carrier_invoice/gst', request, 1).subscribe(
        (res: any) => {

          if (res.statusCode == 200) {

            // this.isCarrierInvoiceCalculate = true;
            this.isCarrierInvoiceDisabled = false;

            this.totalPreTaxAmount = res.data.total_pre_tax_amount;
            this.totalTaxAmount = res.data.total_tax_amount;
            this.totalCharges = res.data.total_amount;
            this.gstID = res.data._id;
            //this.snackbar.openSnackBar(this.messages.SHIPMENT_DETAILS.FREIGHT.SUCCESS.APPROVED);         
          }
        },
        (err: any) => {

          this.snackbar.openSnackBar(err.error.message, '', 'err');
        }

      );
    }
  }

  setDate(date, change = '', i) {
    this.newCarrierInvoiceArray[i].date = this.timeService.toUTCEpoch(date);
  }

  validate() {


    if (this.newCarrierInvoiceArray.length) {

      for (let i = 0; i < this.newCarrierInvoiceArray.length; i++) {
        const invoiceProducts = this.newCarrierInvoiceArray[i];
        if (this.valid.isEmpty(invoiceProducts.service_desc)) {
          this.snackbar.openSnackBar('Please fill service_desc ' + (i + 1) + ' correctly', '', 'err');
          return false;
        }

        if (this.valid.isEmpty(invoiceProducts.pre_tax)) {
          this.snackbar.openSnackBar('Please fill pre_tax ' + (i + 1) + ' correctly', '', 'err');
          return false;
        }

      }
      return true;

    } else {

    }
  }

  // onChangeDetectUpdate() {
  //   // this.isCarrierInvoiceDisabled = false;
  // }
  openVideoLink() {

    this.uploadDocsRef = this.dialogModal.open(this.openVideos, {

    });
  }

}
